!(function (a) {
        a.fn.simpleConfirm = function (e) {
        void 0 === e && (e = {});
        return (
            (e = a.extend({ title: "Confirm", message: "", acceptLabel: "I agree to the terms", success: function () {}, cancel: function () {} }, e)),
            this.each(function () {
                var s,
                    l = a(this);
                l.addClass("simple-dialog active"),
                    (s = '<div class="simple-dialog-content">'),
                    (s += '<div class="simple-dialog-body"><p class="message">' + e.message + '</p><p class="checkbox-container"><input type="checkbox" id="agree"><label for="agree">' + e.acceptLabel + '</label></p></div>'),
                    (s += "</div>"),
                    l.html(s);

                l.find('.simple-dialog-content').on('click', function (t) {
                    t.stopPropagation();
                });

                l.find('#agree').on('change', function () {
                    if (this.checked) {
                        e.success();
                    }
                });

                setTimeout(function() {
                    a(document).on('click.simpleConfirm', function (t) {
                        if (!a(t.target).closest('.simple-dialog-content').length) {
                            l.removeClass("active");
                            e.cancel();
                            a(document).off('click.simpleConfirm');
                        }
                    });
                }, 100);
            }),
            this
        );
    }
})(jQuery);

!function(i){"use strict";"function"==typeof define&&define.amd?define(["jquery"],i):"undefined"!=typeof exports?module.exports=i(require("jquery")):i(jQuery)}(function(i){"use strict";var e=window.Slick||{};(e=function(){var e=0;return function(t,o){var s,n=this;n.defaults={accessibility:!0,adaptiveHeight:!1,appendArrows:i(t),appendDots:i(t),arrows:!0,asNavFor:null,prevArrow:'<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',nextArrow:'<button class="slick-next" aria-label="Next" type="button">Next</button>',autoplay:!1,autoplaySpeed:3e3,centerMode:!1,centerPadding:"50px",cssEase:"ease",customPaging:function(e,t){return i('<button type="button" />').text(t+1)},dots:!1,dotsClass:"slick-dots",draggable:!0,easing:"linear",edgeFriction:.35,fade:!1,focusOnSelect:!1,focusOnChange:!1,infinite:!0,initialSlide:0,lazyLoad:"ondemand",mobileFirst:!1,pauseOnHover:!0,pauseOnFocus:!0,pauseOnDotsHover:!1,respondTo:"window",responsive:null,rows:1,rtl:!1,slide:"",slidesPerRow:1,slidesToShow:1,slidesToScroll:1,speed:500,swipe:!0,swipeToSlide:!1,touchMove:!0,touchThreshold:5,useCSS:!0,useTransform:!0,variableWidth:!1,vertical:!1,verticalSwiping:!1,waitForAnimate:!0,zIndex:1e3},n.initials={animating:!1,dragging:!1,autoPlayTimer:null,currentDirection:0,currentLeft:null,currentSlide:0,direction:1,$dots:null,listWidth:null,listHeight:null,loadIndex:0,$nextArrow:null,$prevArrow:null,scrolling:!1,slideCount:null,slideWidth:null,$slideTrack:null,$slides:null,sliding:!1,slideOffset:0,swipeLeft:null,swiping:!1,$list:null,touchObject:{},transformsEnabled:!1,unslicked:!1},i.extend(n,n.initials),n.activeBreakpoint=null,n.animType=null,n.animProp=null,n.breakpoints=[],n.breakpointSettings=[],n.cssTransitions=!1,n.focussed=!1,n.interrupted=!1,n.hidden="hidden",n.paused=!0,n.positionProp=null,n.respondTo=null,n.rowCount=1,n.shouldClick=!0,n.$slider=i(t),n.$slidesCache=null,n.transformType=null,n.transitionType=null,n.visibilityChange="visibilitychange",n.windowWidth=0,n.windowTimer=null,s=i(t).data("slick")||{},n.options=i.extend({},n.defaults,o,s),n.currentSlide=n.options.initialSlide,n.originalSettings=n.options,void 0!==document.mozHidden?(n.hidden="mozHidden",n.visibilityChange="mozvisibilitychange"):void 0!==document.webkitHidden&&(n.hidden="webkitHidden",n.visibilityChange="webkitvisibilitychange"),n.autoPlay=i.proxy(n.autoPlay,n),n.autoPlayClear=i.proxy(n.autoPlayClear,n),n.autoPlayIterator=i.proxy(n.autoPlayIterator,n),n.changeSlide=i.proxy(n.changeSlide,n),n.clickHandler=i.proxy(n.clickHandler,n),n.selectHandler=i.proxy(n.selectHandler,n),n.setPosition=i.proxy(n.setPosition,n),n.swipeHandler=i.proxy(n.swipeHandler,n),n.dragHandler=i.proxy(n.dragHandler,n),n.keyHandler=i.proxy(n.keyHandler,n),n.instanceUid=e++,n.htmlExpr=/^(?:\s*(<[\w\W]+>)[^>]*)$/,n.registerBreakpoints(),n.init(!0)}}()).prototype.activateADA=function(){this.$slideTrack.find(".slick-active").attr({"aria-hidden":"false"}).find("a, input, button, select").attr({tabindex:"0"})},e.prototype.addSlide=e.prototype.slickAdd=function(e,t,o){var s=this;if("boolean"==typeof t)o=t,t=null;else if(t<0||t>=s.slideCount)return!1;s.unload(),"number"==typeof t?0===t&&0===s.$slides.length?i(e).appendTo(s.$slideTrack):o?i(e).insertBefore(s.$slides.eq(t)):i(e).insertAfter(s.$slides.eq(t)):!0===o?i(e).prependTo(s.$slideTrack):i(e).appendTo(s.$slideTrack),s.$slides=s.$slideTrack.children(this.options.slide),s.$slideTrack.children(this.options.slide).detach(),s.$slideTrack.append(s.$slides),s.$slides.each(function(e,t){i(t).attr("data-slick-index",e)}),s.$slidesCache=s.$slides,s.reinit()},e.prototype.animateHeight=function(){var i=this;if(1===i.options.slidesToShow&&!0===i.options.adaptiveHeight&&!1===i.options.vertical){var e=i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.animate({height:e},i.options.speed)}},e.prototype.animateSlide=function(e,t){var o={},s=this;s.animateHeight(),!0===s.options.rtl&&!1===s.options.vertical&&(e=-e),!1===s.transformsEnabled?!1===s.options.vertical?s.$slideTrack.animate({left:e},s.options.speed,s.options.easing,t):s.$slideTrack.animate({top:e},s.options.speed,s.options.easing,t):!1===s.cssTransitions?(!0===s.options.rtl&&(s.currentLeft=-s.currentLeft),i({animStart:s.currentLeft}).animate({animStart:e},{duration:s.options.speed,easing:s.options.easing,step:function(i){i=Math.ceil(i),!1===s.options.vertical?(o[s.animType]="translate("+i+"px, 0px)",s.$slideTrack.css(o)):(o[s.animType]="translate(0px,"+i+"px)",s.$slideTrack.css(o))},complete:function(){t&&t.call()}})):(s.applyTransition(),e=Math.ceil(e),!1===s.options.vertical?o[s.animType]="translate3d("+e+"px, 0px, 0px)":o[s.animType]="translate3d(0px,"+e+"px, 0px)",s.$slideTrack.css(o),t&&setTimeout(function(){s.disableTransition(),t.call()},s.options.speed))},e.prototype.getNavTarget=function(){var e=this,t=e.options.asNavFor;return t&&null!==t&&(t=i(t).not(e.$slider)),t},e.prototype.asNavFor=function(e){var t=this.getNavTarget();null!==t&&"object"==typeof t&&t.each(function(){var t=i(this).slick("getSlick");t.unslicked||t.slideHandler(e,!0)})},e.prototype.applyTransition=function(i){var e=this,t={};!1===e.options.fade?t[e.transitionType]=e.transformType+" "+e.options.speed+"ms "+e.options.cssEase:t[e.transitionType]="opacity "+e.options.speed+"ms "+e.options.cssEase,!1===e.options.fade?e.$slideTrack.css(t):e.$slides.eq(i).css(t)},e.prototype.autoPlay=function(){var i=this;i.autoPlayClear(),i.slideCount>i.options.slidesToShow&&(i.autoPlayTimer=setInterval(i.autoPlayIterator,i.options.autoplaySpeed))},e.prototype.autoPlayClear=function(){var i=this;i.autoPlayTimer&&clearInterval(i.autoPlayTimer)},e.prototype.autoPlayIterator=function(){var i=this,e=i.currentSlide+i.options.slidesToScroll;i.paused||i.interrupted||i.focussed||(!1===i.options.infinite&&(1===i.direction&&i.currentSlide+1===i.slideCount-1?i.direction=0:0===i.direction&&(e=i.currentSlide-i.options.slidesToScroll,i.currentSlide-1==0&&(i.direction=1))),i.slideHandler(e))},e.prototype.buildArrows=function(){var e=this;!0===e.options.arrows&&(e.$prevArrow=i(e.options.prevArrow).addClass("slick-arrow"),e.$nextArrow=i(e.options.nextArrow).addClass("slick-arrow"),e.slideCount>e.options.slidesToShow?(e.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.prependTo(e.options.appendArrows),e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.appendTo(e.options.appendArrows),!0!==e.options.infinite&&e.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true")):e.$prevArrow.add(e.$nextArrow).addClass("slick-hidden").attr({"aria-disabled":"true",tabindex:"-1"}))},e.prototype.buildDots=function(){var e,t,o=this;if(!0===o.options.dots){for(o.$slider.addClass("slick-dotted"),t=i("<ul />").addClass(o.options.dotsClass),e=0;e<=o.getDotCount();e+=1)t.append(i("<li />").append(o.options.customPaging.call(this,o,e)));o.$dots=t.appendTo(o.options.appendDots),o.$dots.find("li").first().addClass("slick-active")}},e.prototype.buildOut=function(){var e=this;e.$slides=e.$slider.children(e.options.slide+":not(.slick-cloned)").addClass("slick-slide"),e.slideCount=e.$slides.length,e.$slides.each(function(e,t){i(t).attr("data-slick-index",e).data("originalStyling",i(t).attr("style")||"")}),e.$slider.addClass("slick-slider"),e.$slideTrack=0===e.slideCount?i('<div class="slick-track"/>').appendTo(e.$slider):e.$slides.wrapAll('<div class="slick-track"/>').parent(),e.$list=e.$slideTrack.wrap('<div class="slick-list"/>').parent(),e.$slideTrack.css("opacity",0),!0!==e.options.centerMode&&!0!==e.options.swipeToSlide||(e.options.slidesToScroll=1),i("img[data-lazy]",e.$slider).not("[src]").addClass("slick-loading"),e.setupInfinite(),e.buildArrows(),e.buildDots(),e.updateDots(),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),!0===e.options.draggable&&e.$list.addClass("draggable")},e.prototype.buildRows=function(){var i,e,t,o,s,n,r,l=this;if(o=document.createDocumentFragment(),n=l.$slider.children(),l.options.rows>1){for(r=l.options.slidesPerRow*l.options.rows,s=Math.ceil(n.length/r),i=0;i<s;i++){var d=document.createElement("div");for(e=0;e<l.options.rows;e++){var a=document.createElement("div");for(t=0;t<l.options.slidesPerRow;t++){var c=i*r+(e*l.options.slidesPerRow+t);n.get(c)&&a.appendChild(n.get(c))}d.appendChild(a)}o.appendChild(d)}l.$slider.empty().append(o),l.$slider.children().children().children().css({width:100/l.options.slidesPerRow+"%",display:"inline-block"})}},e.prototype.checkResponsive=function(e,t){var o,s,n,r=this,l=!1,d=r.$slider.width(),a=window.innerWidth||i(window).width();if("window"===r.respondTo?n=a:"slider"===r.respondTo?n=d:"min"===r.respondTo&&(n=Math.min(a,d)),r.options.responsive&&r.options.responsive.length&&null!==r.options.responsive){s=null;for(o in r.breakpoints)r.breakpoints.hasOwnProperty(o)&&(!1===r.originalSettings.mobileFirst?n<r.breakpoints[o]&&(s=r.breakpoints[o]):n>r.breakpoints[o]&&(s=r.breakpoints[o]));null!==s?null!==r.activeBreakpoint?(s!==r.activeBreakpoint||t)&&(r.activeBreakpoint=s,"unslick"===r.breakpointSettings[s]?r.unslick(s):(r.options=i.extend({},r.originalSettings,r.breakpointSettings[s]),!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e)),l=s):(r.activeBreakpoint=s,"unslick"===r.breakpointSettings[s]?r.unslick(s):(r.options=i.extend({},r.originalSettings,r.breakpointSettings[s]),!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e)),l=s):null!==r.activeBreakpoint&&(r.activeBreakpoint=null,r.options=r.originalSettings,!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e),l=s),e||!1===l||r.$slider.trigger("breakpoint",[r,l])}},e.prototype.changeSlide=function(e,t){var o,s,n,r=this,l=i(e.currentTarget);switch(l.is("a")&&e.preventDefault(),l.is("li")||(l=l.closest("li")),n=r.slideCount%r.options.slidesToScroll!=0,o=n?0:(r.slideCount-r.currentSlide)%r.options.slidesToScroll,e.data.message){case"previous":s=0===o?r.options.slidesToScroll:r.options.slidesToShow-o,r.slideCount>r.options.slidesToShow&&r.slideHandler(r.currentSlide-s,!1,t);break;case"next":s=0===o?r.options.slidesToScroll:o,r.slideCount>r.options.slidesToShow&&r.slideHandler(r.currentSlide+s,!1,t);break;case"index":var d=0===e.data.index?0:e.data.index||l.index()*r.options.slidesToScroll;r.slideHandler(r.checkNavigable(d),!1,t),l.children().trigger("focus");break;default:return}},e.prototype.checkNavigable=function(i){var e,t;if(e=this.getNavigableIndexes(),t=0,i>e[e.length-1])i=e[e.length-1];else for(var o in e){if(i<e[o]){i=t;break}t=e[o]}return i},e.prototype.cleanUpEvents=function(){var e=this;e.options.dots&&null!==e.$dots&&(i("li",e.$dots).off("click.slick",e.changeSlide).off("mouseenter.slick",i.proxy(e.interrupt,e,!0)).off("mouseleave.slick",i.proxy(e.interrupt,e,!1)),!0===e.options.accessibility&&e.$dots.off("keydown.slick",e.keyHandler)),e.$slider.off("focus.slick blur.slick"),!0===e.options.arrows&&e.slideCount>e.options.slidesToShow&&(e.$prevArrow&&e.$prevArrow.off("click.slick",e.changeSlide),e.$nextArrow&&e.$nextArrow.off("click.slick",e.changeSlide),!0===e.options.accessibility&&(e.$prevArrow&&e.$prevArrow.off("keydown.slick",e.keyHandler),e.$nextArrow&&e.$nextArrow.off("keydown.slick",e.keyHandler))),e.$list.off("touchstart.slick mousedown.slick",e.swipeHandler),e.$list.off("touchmove.slick mousemove.slick",e.swipeHandler),e.$list.off("touchend.slick mouseup.slick",e.swipeHandler),e.$list.off("touchcancel.slick mouseleave.slick",e.swipeHandler),e.$list.off("click.slick",e.clickHandler),i(document).off(e.visibilityChange,e.visibility),e.cleanUpSlideEvents(),!0===e.options.accessibility&&e.$list.off("keydown.slick",e.keyHandler),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().off("click.slick",e.selectHandler),i(window).off("orientationchange.slick.slick-"+e.instanceUid,e.orientationChange),i(window).off("resize.slick.slick-"+e.instanceUid,e.resize),i("[draggable!=true]",e.$slideTrack).off("dragstart",e.preventDefault),i(window).off("load.slick.slick-"+e.instanceUid,e.setPosition)},e.prototype.cleanUpSlideEvents=function(){var e=this;e.$list.off("mouseenter.slick",i.proxy(e.interrupt,e,!0)),e.$list.off("mouseleave.slick",i.proxy(e.interrupt,e,!1))},e.prototype.cleanUpRows=function(){var i,e=this;e.options.rows>1&&((i=e.$slides.children().children()).removeAttr("style"),e.$slider.empty().append(i))},e.prototype.clickHandler=function(i){!1===this.shouldClick&&(i.stopImmediatePropagation(),i.stopPropagation(),i.preventDefault())},e.prototype.destroy=function(e){var t=this;t.autoPlayClear(),t.touchObject={},t.cleanUpEvents(),i(".slick-cloned",t.$slider).detach(),t.$dots&&t.$dots.remove(),t.$prevArrow&&t.$prevArrow.length&&(t.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),t.htmlExpr.test(t.options.prevArrow)&&t.$prevArrow.remove()),t.$nextArrow&&t.$nextArrow.length&&(t.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),t.htmlExpr.test(t.options.nextArrow)&&t.$nextArrow.remove()),t.$slides&&(t.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function(){i(this).attr("style",i(this).data("originalStyling"))}),t.$slideTrack.children(this.options.slide).detach(),t.$slideTrack.detach(),t.$list.detach(),t.$slider.append(t.$slides)),t.cleanUpRows(),t.$slider.removeClass("slick-slider"),t.$slider.removeClass("slick-initialized"),t.$slider.removeClass("slick-dotted"),t.unslicked=!0,e||t.$slider.trigger("destroy",[t])},e.prototype.disableTransition=function(i){var e=this,t={};t[e.transitionType]="",!1===e.options.fade?e.$slideTrack.css(t):e.$slides.eq(i).css(t)},e.prototype.fadeSlide=function(i,e){var t=this;!1===t.cssTransitions?(t.$slides.eq(i).css({zIndex:t.options.zIndex}),t.$slides.eq(i).animate({opacity:1},t.options.speed,t.options.easing,e)):(t.applyTransition(i),t.$slides.eq(i).css({opacity:1,zIndex:t.options.zIndex}),e&&setTimeout(function(){t.disableTransition(i),e.call()},t.options.speed))},e.prototype.fadeSlideOut=function(i){var e=this;!1===e.cssTransitions?e.$slides.eq(i).animate({opacity:0,zIndex:e.options.zIndex-2},e.options.speed,e.options.easing):(e.applyTransition(i),e.$slides.eq(i).css({opacity:0,zIndex:e.options.zIndex-2}))},e.prototype.filterSlides=e.prototype.slickFilter=function(i){var e=this;null!==i&&(e.$slidesCache=e.$slides,e.unload(),e.$slideTrack.children(this.options.slide).detach(),e.$slidesCache.filter(i).appendTo(e.$slideTrack),e.reinit())},e.prototype.focusHandler=function(){var e=this;e.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick","*",function(t){t.stopImmediatePropagation();var o=i(this);setTimeout(function(){e.options.pauseOnFocus&&(e.focussed=o.is(":focus"),e.autoPlay())},0)})},e.prototype.getCurrent=e.prototype.slickCurrentSlide=function(){return this.currentSlide},e.prototype.getDotCount=function(){var i=this,e=0,t=0,o=0;if(!0===i.options.infinite)if(i.slideCount<=i.options.slidesToShow)++o;else for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else if(!0===i.options.centerMode)o=i.slideCount;else if(i.options.asNavFor)for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else o=1+Math.ceil((i.slideCount-i.options.slidesToShow)/i.options.slidesToScroll);return o-1},e.prototype.getLeft=function(i){var e,t,o,s,n=this,r=0;return n.slideOffset=0,t=n.$slides.first().outerHeight(!0),!0===n.options.infinite?(n.slideCount>n.options.slidesToShow&&(n.slideOffset=n.slideWidth*n.options.slidesToShow*-1,s=-1,!0===n.options.vertical&&!0===n.options.centerMode&&(2===n.options.slidesToShow?s=-1.5:1===n.options.slidesToShow&&(s=-2)),r=t*n.options.slidesToShow*s),n.slideCount%n.options.slidesToScroll!=0&&i+n.options.slidesToScroll>n.slideCount&&n.slideCount>n.options.slidesToShow&&(i>n.slideCount?(n.slideOffset=(n.options.slidesToShow-(i-n.slideCount))*n.slideWidth*-1,r=(n.options.slidesToShow-(i-n.slideCount))*t*-1):(n.slideOffset=n.slideCount%n.options.slidesToScroll*n.slideWidth*-1,r=n.slideCount%n.options.slidesToScroll*t*-1))):i+n.options.slidesToShow>n.slideCount&&(n.slideOffset=(i+n.options.slidesToShow-n.slideCount)*n.slideWidth,r=(i+n.options.slidesToShow-n.slideCount)*t),n.slideCount<=n.options.slidesToShow&&(n.slideOffset=0,r=0),!0===n.options.centerMode&&n.slideCount<=n.options.slidesToShow?n.slideOffset=n.slideWidth*Math.floor(n.options.slidesToShow)/2-n.slideWidth*n.slideCount/2:!0===n.options.centerMode&&!0===n.options.infinite?n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)-n.slideWidth:!0===n.options.centerMode&&(n.slideOffset=0,n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)),e=!1===n.options.vertical?i*n.slideWidth*-1+n.slideOffset:i*t*-1+r,!0===n.options.variableWidth&&(o=n.slideCount<=n.options.slidesToShow||!1===n.options.infinite?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow),e=!0===n.options.rtl?o[0]?-1*(n.$slideTrack.width()-o[0].offsetLeft-o.width()):0:o[0]?-1*o[0].offsetLeft:0,!0===n.options.centerMode&&(o=n.slideCount<=n.options.slidesToShow||!1===n.options.infinite?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow+1),e=!0===n.options.rtl?o[0]?-1*(n.$slideTrack.width()-o[0].offsetLeft-o.width()):0:o[0]?-1*o[0].offsetLeft:0,e+=(n.$list.width()-o.outerWidth())/2)),e},e.prototype.getOption=e.prototype.slickGetOption=function(i){return this.options[i]},e.prototype.getNavigableIndexes=function(){var i,e=this,t=0,o=0,s=[];for(!1===e.options.infinite?i=e.slideCount:(t=-1*e.options.slidesToScroll,o=-1*e.options.slidesToScroll,i=2*e.slideCount);t<i;)s.push(t),t=o+e.options.slidesToScroll,o+=e.options.slidesToScroll<=e.options.slidesToShow?e.options.slidesToScroll:e.options.slidesToShow;return s},e.prototype.getSlick=function(){return this},e.prototype.getSlideCount=function(){var e,t,o=this;return t=!0===o.options.centerMode?o.slideWidth*Math.floor(o.options.slidesToShow/2):0,!0===o.options.swipeToSlide?(o.$slideTrack.find(".slick-slide").each(function(s,n){if(n.offsetLeft-t+i(n).outerWidth()/2>-1*o.swipeLeft)return e=n,!1}),Math.abs(i(e).attr("data-slick-index")-o.currentSlide)||1):o.options.slidesToScroll},e.prototype.goTo=e.prototype.slickGoTo=function(i,e){this.changeSlide({data:{message:"index",index:parseInt(i)}},e)},e.prototype.init=function(e){var t=this;i(t.$slider).hasClass("slick-initialized")||(i(t.$slider).addClass("slick-initialized"),t.buildRows(),t.buildOut(),t.setProps(),t.startLoad(),t.loadSlider(),t.initializeEvents(),t.updateArrows(),t.updateDots(),t.checkResponsive(!0),t.focusHandler()),e&&t.$slider.trigger("init",[t]),!0===t.options.accessibility&&t.initADA(),t.options.autoplay&&(t.paused=!1,t.autoPlay())},e.prototype.initADA=function(){var e=this,t=Math.ceil(e.slideCount/e.options.slidesToShow),o=e.getNavigableIndexes().filter(function(i){return i>=0&&i<e.slideCount});e.$slides.add(e.$slideTrack.find(".slick-cloned")).attr({"aria-hidden":"true",tabindex:"-1"}).find("a, input, button, select").attr({tabindex:"-1"}),null!==e.$dots&&(e.$slides.not(e.$slideTrack.find(".slick-cloned")).each(function(t){var s=o.indexOf(t);i(this).attr({role:"tabpanel",id:"slick-slide"+e.instanceUid+t,tabindex:-1}),-1!==s&&i(this).attr({"aria-describedby":"slick-slide-control"+e.instanceUid+s})}),e.$dots.attr("role","tablist").find("li").each(function(s){var n=o[s];i(this).attr({role:"presentation"}),i(this).find("button").first().attr({role:"tab",id:"slick-slide-control"+e.instanceUid+s,"aria-controls":"slick-slide"+e.instanceUid+n,"aria-label":s+1+" of "+t,"aria-selected":null,tabindex:"-1"})}).eq(e.currentSlide).find("button").attr({"aria-selected":"true",tabindex:"0"}).end());for(var s=e.currentSlide,n=s+e.options.slidesToShow;s<n;s++)e.$slides.eq(s).attr("tabindex",0);e.activateADA()},e.prototype.initArrowEvents=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.off("click.slick").on("click.slick",{message:"previous"},i.changeSlide),i.$nextArrow.off("click.slick").on("click.slick",{message:"next"},i.changeSlide),!0===i.options.accessibility&&(i.$prevArrow.on("keydown.slick",i.keyHandler),i.$nextArrow.on("keydown.slick",i.keyHandler)))},e.prototype.initDotEvents=function(){var e=this;!0===e.options.dots&&(i("li",e.$dots).on("click.slick",{message:"index"},e.changeSlide),!0===e.options.accessibility&&e.$dots.on("keydown.slick",e.keyHandler)),!0===e.options.dots&&!0===e.options.pauseOnDotsHover&&i("li",e.$dots).on("mouseenter.slick",i.proxy(e.interrupt,e,!0)).on("mouseleave.slick",i.proxy(e.interrupt,e,!1))},e.prototype.initSlideEvents=function(){var e=this;e.options.pauseOnHover&&(e.$list.on("mouseenter.slick",i.proxy(e.interrupt,e,!0)),e.$list.on("mouseleave.slick",i.proxy(e.interrupt,e,!1)))},e.prototype.initializeEvents=function(){var e=this;e.initArrowEvents(),e.initDotEvents(),e.initSlideEvents(),e.$list.on("touchstart.slick mousedown.slick",{action:"start"},e.swipeHandler),e.$list.on("touchmove.slick mousemove.slick",{action:"move"},e.swipeHandler),e.$list.on("touchend.slick mouseup.slick",{action:"end"},e.swipeHandler),e.$list.on("touchcancel.slick mouseleave.slick",{action:"end"},e.swipeHandler),e.$list.on("click.slick",e.clickHandler),i(document).on(e.visibilityChange,i.proxy(e.visibility,e)),!0===e.options.accessibility&&e.$list.on("keydown.slick",e.keyHandler),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().on("click.slick",e.selectHandler),i(window).on("orientationchange.slick.slick-"+e.instanceUid,i.proxy(e.orientationChange,e)),i(window).on("resize.slick.slick-"+e.instanceUid,i.proxy(e.resize,e)),i("[draggable!=true]",e.$slideTrack).on("dragstart",e.preventDefault),i(window).on("load.slick.slick-"+e.instanceUid,e.setPosition),i(e.setPosition)},e.prototype.initUI=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.show(),i.$nextArrow.show()),!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&i.$dots.show()},e.prototype.keyHandler=function(i){var e=this;i.target.tagName.match("TEXTAREA|INPUT|SELECT")||(37===i.keyCode&&!0===e.options.accessibility?e.changeSlide({data:{message:!0===e.options.rtl?"next":"previous"}}):39===i.keyCode&&!0===e.options.accessibility&&e.changeSlide({data:{message:!0===e.options.rtl?"previous":"next"}}))},e.prototype.lazyLoad=function(){function e(e){i("img[data-lazy]",e).each(function(){var e=i(this),t=i(this).attr("data-lazy"),o=i(this).attr("data-srcset"),s=i(this).attr("data-sizes")||n.$slider.attr("data-sizes"),r=document.createElement("img");r.onload=function(){e.animate({opacity:0},100,function(){o&&(e.attr("srcset",o),s&&e.attr("sizes",s)),e.attr("src",t).animate({opacity:1},200,function(){e.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading")}),n.$slider.trigger("lazyLoaded",[n,e,t])})},r.onerror=function(){e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),n.$slider.trigger("lazyLoadError",[n,e,t])},r.src=t})}var t,o,s,n=this;if(!0===n.options.centerMode?!0===n.options.infinite?s=(o=n.currentSlide+(n.options.slidesToShow/2+1))+n.options.slidesToShow+2:(o=Math.max(0,n.currentSlide-(n.options.slidesToShow/2+1)),s=n.options.slidesToShow/2+1+2+n.currentSlide):(o=n.options.infinite?n.options.slidesToShow+n.currentSlide:n.currentSlide,s=Math.ceil(o+n.options.slidesToShow),!0===n.options.fade&&(o>0&&o--,s<=n.slideCount&&s++)),t=n.$slider.find(".slick-slide").slice(o,s),"anticipated"===n.options.lazyLoad)for(var r=o-1,l=s,d=n.$slider.find(".slick-slide"),a=0;a<n.options.slidesToScroll;a++)r<0&&(r=n.slideCount-1),t=(t=t.add(d.eq(r))).add(d.eq(l)),r--,l++;e(t),n.slideCount<=n.options.slidesToShow?e(n.$slider.find(".slick-slide")):n.currentSlide>=n.slideCount-n.options.slidesToShow?e(n.$slider.find(".slick-cloned").slice(0,n.options.slidesToShow)):0===n.currentSlide&&e(n.$slider.find(".slick-cloned").slice(-1*n.options.slidesToShow))},e.prototype.loadSlider=function(){var i=this;i.setPosition(),i.$slideTrack.css({opacity:1}),i.$slider.removeClass("slick-loading"),i.initUI(),"progressive"===i.options.lazyLoad&&i.progressiveLazyLoad()},e.prototype.next=e.prototype.slickNext=function(){this.changeSlide({data:{message:"next"}})},e.prototype.orientationChange=function(){var i=this;i.checkResponsive(),i.setPosition()},e.prototype.pause=e.prototype.slickPause=function(){var i=this;i.autoPlayClear(),i.paused=!0},e.prototype.play=e.prototype.slickPlay=function(){var i=this;i.autoPlay(),i.options.autoplay=!0,i.paused=!1,i.focussed=!1,i.interrupted=!1},e.prototype.postSlide=function(e){var t=this;t.unslicked||(t.$slider.trigger("afterChange",[t,e]),t.animating=!1,t.slideCount>t.options.slidesToShow&&t.setPosition(),t.swipeLeft=null,t.options.autoplay&&t.autoPlay(),!0===t.options.accessibility&&(t.initADA(),t.options.focusOnChange&&i(t.$slides.get(t.currentSlide)).attr("tabindex",0).focus()))},e.prototype.prev=e.prototype.slickPrev=function(){this.changeSlide({data:{message:"previous"}})},e.prototype.preventDefault=function(i){i.preventDefault()},e.prototype.progressiveLazyLoad=function(e){e=e||1;var t,o,s,n,r,l=this,d=i("img[data-lazy]",l.$slider);d.length?(t=d.first(),o=t.attr("data-lazy"),s=t.attr("data-srcset"),n=t.attr("data-sizes")||l.$slider.attr("data-sizes"),(r=document.createElement("img")).onload=function(){s&&(t.attr("srcset",s),n&&t.attr("sizes",n)),t.attr("src",o).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"),!0===l.options.adaptiveHeight&&l.setPosition(),l.$slider.trigger("lazyLoaded",[l,t,o]),l.progressiveLazyLoad()},r.onerror=function(){e<3?setTimeout(function(){l.progressiveLazyLoad(e+1)},500):(t.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),l.$slider.trigger("lazyLoadError",[l,t,o]),l.progressiveLazyLoad())},r.src=o):l.$slider.trigger("allImagesLoaded",[l])},e.prototype.refresh=function(e){var t,o,s=this;o=s.slideCount-s.options.slidesToShow,!s.options.infinite&&s.currentSlide>o&&(s.currentSlide=o),s.slideCount<=s.options.slidesToShow&&(s.currentSlide=0),t=s.currentSlide,s.destroy(!0),i.extend(s,s.initials,{currentSlide:t}),s.init(),e||s.changeSlide({data:{message:"index",index:t}},!1)},e.prototype.registerBreakpoints=function(){var e,t,o,s=this,n=s.options.responsive||null;if("array"===i.type(n)&&n.length){s.respondTo=s.options.respondTo||"window";for(e in n)if(o=s.breakpoints.length-1,n.hasOwnProperty(e)){for(t=n[e].breakpoint;o>=0;)s.breakpoints[o]&&s.breakpoints[o]===t&&s.breakpoints.splice(o,1),o--;s.breakpoints.push(t),s.breakpointSettings[t]=n[e].settings}s.breakpoints.sort(function(i,e){return s.options.mobileFirst?i-e:e-i})}},e.prototype.reinit=function(){var e=this;e.$slides=e.$slideTrack.children(e.options.slide).addClass("slick-slide"),e.slideCount=e.$slides.length,e.currentSlide>=e.slideCount&&0!==e.currentSlide&&(e.currentSlide=e.currentSlide-e.options.slidesToScroll),e.slideCount<=e.options.slidesToShow&&(e.currentSlide=0),e.registerBreakpoints(),e.setProps(),e.setupInfinite(),e.buildArrows(),e.updateArrows(),e.initArrowEvents(),e.buildDots(),e.updateDots(),e.initDotEvents(),e.cleanUpSlideEvents(),e.initSlideEvents(),e.checkResponsive(!1,!0),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().on("click.slick",e.selectHandler),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),e.setPosition(),e.focusHandler(),e.paused=!e.options.autoplay,e.autoPlay(),e.$slider.trigger("reInit",[e])},e.prototype.resize=function(){var e=this;i(window).width()!==e.windowWidth&&(clearTimeout(e.windowDelay),e.windowDelay=window.setTimeout(function(){e.windowWidth=i(window).width(),e.checkResponsive(),e.unslicked||e.setPosition()},50))},e.prototype.removeSlide=e.prototype.slickRemove=function(i,e,t){var o=this;if(i="boolean"==typeof i?!0===(e=i)?0:o.slideCount-1:!0===e?--i:i,o.slideCount<1||i<0||i>o.slideCount-1)return!1;o.unload(),!0===t?o.$slideTrack.children().remove():o.$slideTrack.children(this.options.slide).eq(i).remove(),o.$slides=o.$slideTrack.children(this.options.slide),o.$slideTrack.children(this.options.slide).detach(),o.$slideTrack.append(o.$slides),o.$slidesCache=o.$slides,o.reinit()},e.prototype.setCSS=function(i){var e,t,o=this,s={};!0===o.options.rtl&&(i=-i),e="left"==o.positionProp?Math.ceil(i)+"px":"0px",t="top"==o.positionProp?Math.ceil(i)+"px":"0px",s[o.positionProp]=i,!1===o.transformsEnabled?o.$slideTrack.css(s):(s={},!1===o.cssTransitions?(s[o.animType]="translate("+e+", "+t+")",o.$slideTrack.css(s)):(s[o.animType]="translate3d("+e+", "+t+", 0px)",o.$slideTrack.css(s)))},e.prototype.setDimensions=function(){var i=this;!1===i.options.vertical?!0===i.options.centerMode&&i.$list.css({padding:"0px "+i.options.centerPadding}):(i.$list.height(i.$slides.first().outerHeight(!0)*i.options.slidesToShow),!0===i.options.centerMode&&i.$list.css({padding:i.options.centerPadding+" 0px"})),i.listWidth=i.$list.width(),i.listHeight=i.$list.height(),!1===i.options.vertical&&!1===i.options.variableWidth?(i.slideWidth=Math.ceil(i.listWidth/i.options.slidesToShow),i.$slideTrack.width(Math.ceil(i.slideWidth*i.$slideTrack.children(".slick-slide").length))):!0===i.options.variableWidth?i.$slideTrack.width(5e3*i.slideCount):(i.slideWidth=Math.ceil(i.listWidth),i.$slideTrack.height(Math.ceil(i.$slides.first().outerHeight(!0)*i.$slideTrack.children(".slick-slide").length)));var e=i.$slides.first().outerWidth(!0)-i.$slides.first().width();!1===i.options.variableWidth&&i.$slideTrack.children(".slick-slide").width(i.slideWidth-e)},e.prototype.setFade=function(){var e,t=this;t.$slides.each(function(o,s){e=t.slideWidth*o*-1,!0===t.options.rtl?i(s).css({position:"relative",right:e,top:0,zIndex:t.options.zIndex-2,opacity:0}):i(s).css({position:"relative",left:e,top:0,zIndex:t.options.zIndex-2,opacity:0})}),t.$slides.eq(t.currentSlide).css({zIndex:t.options.zIndex-1,opacity:1})},e.prototype.setHeight=function(){var i=this;if(1===i.options.slidesToShow&&!0===i.options.adaptiveHeight&&!1===i.options.vertical){var e=i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.css("height",e)}},e.prototype.setOption=e.prototype.slickSetOption=function(){var e,t,o,s,n,r=this,l=!1;if("object"===i.type(arguments[0])?(o=arguments[0],l=arguments[1],n="multiple"):"string"===i.type(arguments[0])&&(o=arguments[0],s=arguments[1],l=arguments[2],"responsive"===arguments[0]&&"array"===i.type(arguments[1])?n="responsive":void 0!==arguments[1]&&(n="single")),"single"===n)r.options[o]=s;else if("multiple"===n)i.each(o,function(i,e){r.options[i]=e});else if("responsive"===n)for(t in s)if("array"!==i.type(r.options.responsive))r.options.responsive=[s[t]];else{for(e=r.options.responsive.length-1;e>=0;)r.options.responsive[e].breakpoint===s[t].breakpoint&&r.options.responsive.splice(e,1),e--;r.options.responsive.push(s[t])}l&&(r.unload(),r.reinit())},e.prototype.setPosition=function(){var i=this;i.setDimensions(),i.setHeight(),!1===i.options.fade?i.setCSS(i.getLeft(i.currentSlide)):i.setFade(),i.$slider.trigger("setPosition",[i])},e.prototype.setProps=function(){var i=this,e=document.body.style;i.positionProp=!0===i.options.vertical?"top":"left","top"===i.positionProp?i.$slider.addClass("slick-vertical"):i.$slider.removeClass("slick-vertical"),void 0===e.WebkitTransition&&void 0===e.MozTransition&&void 0===e.msTransition||!0===i.options.useCSS&&(i.cssTransitions=!0),i.options.fade&&("number"==typeof i.options.zIndex?i.options.zIndex<3&&(i.options.zIndex=3):i.options.zIndex=i.defaults.zIndex),void 0!==e.OTransform&&(i.animType="OTransform",i.transformType="-o-transform",i.transitionType="OTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.MozTransform&&(i.animType="MozTransform",i.transformType="-moz-transform",i.transitionType="MozTransition",void 0===e.perspectiveProperty&&void 0===e.MozPerspective&&(i.animType=!1)),void 0!==e.webkitTransform&&(i.animType="webkitTransform",i.transformType="-webkit-transform",i.transitionType="webkitTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.msTransform&&(i.animType="msTransform",i.transformType="-ms-transform",i.transitionType="msTransition",void 0===e.msTransform&&(i.animType=!1)),void 0!==e.transform&&!1!==i.animType&&(i.animType="transform",i.transformType="transform",i.transitionType="transition"),i.transformsEnabled=i.options.useTransform&&null!==i.animType&&!1!==i.animType},e.prototype.setSlideClasses=function(i){var e,t,o,s,n=this;if(t=n.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden","true"),n.$slides.eq(i).addClass("slick-current"),!0===n.options.centerMode){var r=n.options.slidesToShow%2==0?1:0;e=Math.floor(n.options.slidesToShow/2),!0===n.options.infinite&&(i>=e&&i<=n.slideCount-1-e?n.$slides.slice(i-e+r,i+e+1).addClass("slick-active").attr("aria-hidden","false"):(o=n.options.slidesToShow+i,t.slice(o-e+1+r,o+e+2).addClass("slick-active").attr("aria-hidden","false")),0===i?t.eq(t.length-1-n.options.slidesToShow).addClass("slick-center"):i===n.slideCount-1&&t.eq(n.options.slidesToShow).addClass("slick-center")),n.$slides.eq(i).addClass("slick-center")}else i>=0&&i<=n.slideCount-n.options.slidesToShow?n.$slides.slice(i,i+n.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"):t.length<=n.options.slidesToShow?t.addClass("slick-active").attr("aria-hidden","false"):(s=n.slideCount%n.options.slidesToShow,o=!0===n.options.infinite?n.options.slidesToShow+i:i,n.options.slidesToShow==n.options.slidesToScroll&&n.slideCount-i<n.options.slidesToShow?t.slice(o-(n.options.slidesToShow-s),o+s).addClass("slick-active").attr("aria-hidden","false"):t.slice(o,o+n.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"));"ondemand"!==n.options.lazyLoad&&"anticipated"!==n.options.lazyLoad||n.lazyLoad()},e.prototype.setupInfinite=function(){var e,t,o,s=this;if(!0===s.options.fade&&(s.options.centerMode=!1),!0===s.options.infinite&&!1===s.options.fade&&(t=null,s.slideCount>s.options.slidesToShow)){for(o=!0===s.options.centerMode?s.options.slidesToShow+1:s.options.slidesToShow,e=s.slideCount;e>s.slideCount-o;e-=1)t=e-1,i(s.$slides[t]).clone(!0).attr("id","").attr("data-slick-index",t-s.slideCount).prependTo(s.$slideTrack).addClass("slick-cloned");for(e=0;e<o+s.slideCount;e+=1)t=e,i(s.$slides[t]).clone(!0).attr("id","").attr("data-slick-index",t+s.slideCount).appendTo(s.$slideTrack).addClass("slick-cloned");s.$slideTrack.find(".slick-cloned").find("[id]").each(function(){i(this).attr("id","")})}},e.prototype.interrupt=function(i){var e=this;i||e.autoPlay(),e.interrupted=i},e.prototype.selectHandler=function(e){var t=this,o=i(e.target).is(".slick-slide")?i(e.target):i(e.target).parents(".slick-slide"),s=parseInt(o.attr("data-slick-index"));s||(s=0),t.slideCount<=t.options.slidesToShow?t.slideHandler(s,!1,!0):t.slideHandler(s)},e.prototype.slideHandler=function(i,e,t){var o,s,n,r,l,d=null,a=this;if(e=e||!1,!(!0===a.animating&&!0===a.options.waitForAnimate||!0===a.options.fade&&a.currentSlide===i))if(!1===e&&a.asNavFor(i),o=i,d=a.getLeft(o),r=a.getLeft(a.currentSlide),a.currentLeft=null===a.swipeLeft?r:a.swipeLeft,!1===a.options.infinite&&!1===a.options.centerMode&&(i<0||i>a.getDotCount()*a.options.slidesToScroll))!1===a.options.fade&&(o=a.currentSlide,!0!==t?a.animateSlide(r,function(){a.postSlide(o)}):a.postSlide(o));else if(!1===a.options.infinite&&!0===a.options.centerMode&&(i<0||i>a.slideCount-a.options.slidesToScroll))!1===a.options.fade&&(o=a.currentSlide,!0!==t?a.animateSlide(r,function(){a.postSlide(o)}):a.postSlide(o));else{if(a.options.autoplay&&clearInterval(a.autoPlayTimer),s=o<0?a.slideCount%a.options.slidesToScroll!=0?a.slideCount-a.slideCount%a.options.slidesToScroll:a.slideCount+o:o>=a.slideCount?a.slideCount%a.options.slidesToScroll!=0?0:o-a.slideCount:o,a.animating=!0,a.$slider.trigger("beforeChange",[a,a.currentSlide,s]),n=a.currentSlide,a.currentSlide=s,a.setSlideClasses(a.currentSlide),a.options.asNavFor&&(l=(l=a.getNavTarget()).slick("getSlick")).slideCount<=l.options.slidesToShow&&l.setSlideClasses(a.currentSlide),a.updateDots(),a.updateArrows(),!0===a.options.fade)return!0!==t?(a.fadeSlideOut(n),a.fadeSlide(s,function(){a.postSlide(s)})):a.postSlide(s),void a.animateHeight();!0!==t?a.animateSlide(d,function(){a.postSlide(s)}):a.postSlide(s)}},e.prototype.startLoad=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.hide(),i.$nextArrow.hide()),!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&i.$dots.hide(),i.$slider.addClass("slick-loading")},e.prototype.swipeDirection=function(){var i,e,t,o,s=this;return i=s.touchObject.startX-s.touchObject.curX,e=s.touchObject.startY-s.touchObject.curY,t=Math.atan2(e,i),(o=Math.round(180*t/Math.PI))<0&&(o=360-Math.abs(o)),o<=45&&o>=0?!1===s.options.rtl?"left":"right":o<=360&&o>=315?!1===s.options.rtl?"left":"right":o>=135&&o<=225?!1===s.options.rtl?"right":"left":!0===s.options.verticalSwiping?o>=35&&o<=135?"down":"up":"vertical"},e.prototype.swipeEnd=function(i){var e,t,o=this;if(o.dragging=!1,o.swiping=!1,o.scrolling)return o.scrolling=!1,!1;if(o.interrupted=!1,o.shouldClick=!(o.touchObject.swipeLength>10),void 0===o.touchObject.curX)return!1;if(!0===o.touchObject.edgeHit&&o.$slider.trigger("edge",[o,o.swipeDirection()]),o.touchObject.swipeLength>=o.touchObject.minSwipe){switch(t=o.swipeDirection()){case"left":case"down":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide+o.getSlideCount()):o.currentSlide+o.getSlideCount(),o.currentDirection=0;break;case"right":case"up":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide-o.getSlideCount()):o.currentSlide-o.getSlideCount(),o.currentDirection=1}"vertical"!=t&&(o.slideHandler(e),o.touchObject={},o.$slider.trigger("swipe",[o,t]))}else o.touchObject.startX!==o.touchObject.curX&&(o.slideHandler(o.currentSlide),o.touchObject={})},e.prototype.swipeHandler=function(i){var e=this;if(!(!1===e.options.swipe||"ontouchend"in document&&!1===e.options.swipe||!1===e.options.draggable&&-1!==i.type.indexOf("mouse")))switch(e.touchObject.fingerCount=i.originalEvent&&void 0!==i.originalEvent.touches?i.originalEvent.touches.length:1,e.touchObject.minSwipe=e.listWidth/e.options.touchThreshold,!0===e.options.verticalSwiping&&(e.touchObject.minSwipe=e.listHeight/e.options.touchThreshold),i.data.action){case"start":e.swipeStart(i);break;case"move":e.swipeMove(i);break;case"end":e.swipeEnd(i)}},e.prototype.swipeMove=function(i){var e,t,o,s,n,r,l=this;return n=void 0!==i.originalEvent?i.originalEvent.touches:null,!(!l.dragging||l.scrolling||n&&1!==n.length)&&(e=l.getLeft(l.currentSlide),l.touchObject.curX=void 0!==n?n[0].pageX:i.clientX,l.touchObject.curY=void 0!==n?n[0].pageY:i.clientY,l.touchObject.swipeLength=Math.round(Math.sqrt(Math.pow(l.touchObject.curX-l.touchObject.startX,2))),r=Math.round(Math.sqrt(Math.pow(l.touchObject.curY-l.touchObject.startY,2))),!l.options.verticalSwiping&&!l.swiping&&r>4?(l.scrolling=!0,!1):(!0===l.options.verticalSwiping&&(l.touchObject.swipeLength=r),t=l.swipeDirection(),void 0!==i.originalEvent&&l.touchObject.swipeLength>4&&(l.swiping=!0,i.preventDefault()),s=(!1===l.options.rtl?1:-1)*(l.touchObject.curX>l.touchObject.startX?1:-1),!0===l.options.verticalSwiping&&(s=l.touchObject.curY>l.touchObject.startY?1:-1),o=l.touchObject.swipeLength,l.touchObject.edgeHit=!1,!1===l.options.infinite&&(0===l.currentSlide&&"right"===t||l.currentSlide>=l.getDotCount()&&"left"===t)&&(o=l.touchObject.swipeLength*l.options.edgeFriction,l.touchObject.edgeHit=!0),!1===l.options.vertical?l.swipeLeft=e+o*s:l.swipeLeft=e+o*(l.$list.height()/l.listWidth)*s,!0===l.options.verticalSwiping&&(l.swipeLeft=e+o*s),!0!==l.options.fade&&!1!==l.options.touchMove&&(!0===l.animating?(l.swipeLeft=null,!1):void l.setCSS(l.swipeLeft))))},e.prototype.swipeStart=function(i){var e,t=this;if(t.interrupted=!0,1!==t.touchObject.fingerCount||t.slideCount<=t.options.slidesToShow)return t.touchObject={},!1;void 0!==i.originalEvent&&void 0!==i.originalEvent.touches&&(e=i.originalEvent.touches[0]),t.touchObject.startX=t.touchObject.curX=void 0!==e?e.pageX:i.clientX,t.touchObject.startY=t.touchObject.curY=void 0!==e?e.pageY:i.clientY,t.dragging=!0},e.prototype.unfilterSlides=e.prototype.slickUnfilter=function(){var i=this;null!==i.$slidesCache&&(i.unload(),i.$slideTrack.children(this.options.slide).detach(),i.$slidesCache.appendTo(i.$slideTrack),i.reinit())},e.prototype.unload=function(){var e=this;i(".slick-cloned",e.$slider).remove(),e.$dots&&e.$dots.remove(),e.$prevArrow&&e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.remove(),e.$nextArrow&&e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.remove(),e.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden","true").css("width","")},e.prototype.unslick=function(i){var e=this;e.$slider.trigger("unslick",[e,i]),e.destroy()},e.prototype.updateArrows=function(){var i=this;Math.floor(i.options.slidesToShow/2),!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&!i.options.infinite&&(i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false"),i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false"),0===i.currentSlide?(i.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false")):i.currentSlide>=i.slideCount-i.options.slidesToShow&&!1===i.options.centerMode?(i.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")):i.currentSlide>=i.slideCount-1&&!0===i.options.centerMode&&(i.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")))},e.prototype.updateDots=function(){var i=this;null!==i.$dots&&(i.$dots.find("li").removeClass("slick-active").end(),i.$dots.find("li").eq(Math.floor(i.currentSlide/i.options.slidesToScroll)).addClass("slick-active"))},e.prototype.visibility=function(){var i=this;i.options.autoplay&&(document[i.hidden]?i.interrupted=!0:i.interrupted=!1)},i.fn.slick=function(){var i,t,o=this,s=arguments[0],n=Array.prototype.slice.call(arguments,1),r=o.length;for(i=0;i<r;i++)if("object"==typeof s||void 0===s?o[i].slick=new e(o[i],s):t=o[i].slick[s].apply(o[i].slick,n),void 0!==t)return t;return o}});
/* global $ _ TweenMax lng Quint Quart TimelineMax Power0 Power1 Power2 Hammer ga Linear Shopify */
'use strict';
var WbshckWeb = (function($,_,tw) {


    // vars
    var ww = $(window).width(),
        wh = $(window).height(),
        $root = $('.UIRoot'),
        touch = false,
        cookiesSettings, cookiesDefault;

    // init
    (function() {

        // browser type
        $('body').addClass($.browser.name);
        $('body').addClass($.browser.platform);
        touch = isTouchDevice();

        // controllers
        globalController();
        headerController();
        if ($('.UIHome').length > 0) homeController();
        if ($('.UIHeroes').length > 0) heroesController();
        if ($('.UIProduct').length > 0) productController();
        if ($('.UICollection').length > 0) collectionController();
        if ($('.UIAccount').length > 0) accountController();
        if ($('.UIAccount.addresses').length > 0) addressesController();
        if ($('.UIContact').length > 0) contactController();
        if ($('.UICart').length > 0) cartController();
        if ($('.UIAux.faq').length > 0) faqController();

    }());

    function globalController() {

        (function() {
            input();
            events();
        }());

        function events() {

            // hide alert bar if user manually selects currency
            $('.alert-bar a.dismiss').off('click').on('click',function(e) {
                if (typeof(Storage) !== 'undefined') {
                    localStorage.setItem('displayAlertBar', false);
                    $('.alert-bar').remove();
                }
            });

            // currency
            $('.UIHeader .currency .close').off('click.wbshck').on('click.wbshck',function(e) {
                e && e.preventDefault();
                // hideSubmenu();
                $('.UIHeader .currency .selected').removeClass('active');
                $('.UIHeader .currency .selector').removeClass('active');
            });
            $('.UIHeader .currency .selected').off('click.wbshck').on('click.wbshck',function(e) {
                e && e.preventDefault();
                // hideSubmenu();
                $('.UIHeader .currency .selected').toggleClass('active');
                $('.UIHeader .currency .selector').toggleClass('active');

                $('.localization .select-slide').slick('refresh');
            });

            // hide notif bar if user manually selects currency
            $('.UIHeader .currency:not(.localization) .selector a').off('click.wbshck.notif').on('click.wbshck.notif',function(e) {
                if (typeof(Storage) !== 'undefined') {
                    localStorage.setItem('displayCurrencyNotification', false);
                }
            });

            // remove currencyNotification
            $('.wbshck .currencyNotification .ok').off('click.wbshck').on('click.wbshck',function(e) {
                e && e.preventDefault();
                $('.wbshck .currencyNotification').remove();
                if (typeof(Storage) !== 'undefined') {
                    localStorage.setItem('displayCurrencyNotification', false);
                }
            });

            // disable blind DEV links
            $root.find('a[href="/"]').off('click.wbshck').on('click.wbshck',function(e) {
                // e && e.preventDefault();
            });

            // resize
            $(window).off('resize.wbshck').on('resize.wbshck',function() {
                ww = $(window).width();
                wh = $(window).height();
            });



        }

        function input() {

            // alert bar notification
            if (typeof(Storage) !== 'undefined') {
                // show alert bar
                if (localStorage.getItem('displayAlertBar') != 'false') {
                    displayAlertBar();
                }
                // diable alert bar localstorage if no alert bar present in the html
                if ($('.alert-bar').length < 1) {
                    localStorage.removeItem('displayAlertBar');
                }
            }

            // currency notification
            if (typeof(Storage) !== 'undefined') {
                if (localStorage.getItem('displayCurrencyNotification') == 'true') {
                    displayCurrencyNotification();
                }
            }
        }

        function displayAlertBar() {
            $('.alert-bar').show();
        }

        function displayCurrencyNotification() {

            var currency = $('.UIHeader .currency').data('currency'),
                $notifcation;

            if (typeof(Storage) !== 'undefined') {
                currency = localStorage.getItem('geolocalCurrency');
            }

            $notifcation = $('<div class="currencyNotification"><b>We\'ve noticed that your local currency is '+ currency +', so '+ currency +' pricing will be displayed. You can change the selected currency in the main menu.</b> <a href="#" class="btn ok">OK!</a></div>');

            $('.wbshck .UIRoot').append($notifcation);

            events();
        }

        function geolocation() {

            var maxTry = 15,
                tryStep = 0,
                supportedCurrencies = [],
                cartCurrency = $('.UIHeader .currency').data('currency'),
                _stopAsking = getStopAsking();


            $('.UIHeader .currency .selector a b').each(function() {
                supportedCurrencies.push($(this).text());
            });

            // console.log(supportedCurrencies, cartCurrency);
            if (supportedCurrencies.length < 1) return;

            clearGeolocationInterval();
            window.geolocationInterval = setInterval(function() {
                checkForGeolocationData();
                tryStep++;
                if (tryStep > maxTry) clearGeolocationInterval();
            },1000);

            function checkForGeolocationData() {
                var geolocalCurrency;
                // console.log('checking('+tryStep+'):', $('.locale-bar__container').length);
                if ($('.locale-bar__container').length > 0) {
                    geolocalCurrency = $('.locale-bar__container input[name="currency_code"]').val();
                    // console.log('stopAsking:'+_stopAsking);
                    if (
                        supportedCurrencies.indexOf(geolocalCurrency)!=-1 &&
                        cartCurrency != geolocalCurrency &&
                        _stopAsking != 'true'
                    ) {
                        // if (confirm('It looks like your local currency is '+geolocalCurrency+'.\nWould you like to switch to this currency?')) {
                        window.location.href='?currency='+geolocalCurrency;
                        // }
                        // stopAsking();
                        stopAskingAndDisplayTheNtification(geolocalCurrency);
                    }
                    // console.log('geolocalCurrency:'+geolocalCurrency);
                    clearGeolocationInterval();
                }
            }

            function getStopAsking() {
                if (typeof(Storage) !== 'undefined') {
                    return localStorage.getItem('stopAsking');
                }
                else {
                    return false;
                }
            }

            function stopAsking() {
                if (typeof(Storage) !== 'undefined') {
                    localStorage.setItem('stopAsking', true);
                }
            }

            function stopAskingAndDisplayTheNtification(geolocalCurrency) {
                if (typeof(Storage) !== 'undefined') {
                    localStorage.setItem('stopAsking', true);
                    localStorage.setItem('displayCurrencyNotification', true);
                    localStorage.setItem('geolocalCurrency', geolocalCurrency);
                }
            }

            function clearGeolocationInterval() {
                (window.geolocationInterval) && (clearInterval(window.geolocationInterval));
            }

        }

    }

    function headerController() {

        (function() {
            markActiveMenu();
            events();
        }());

        function events() {

            // toggle mobile menu
            $('.UIHeader .mobile-btn').off('click').on('click',function(e) {
                e && e.preventDefault();
                $('.UIHeader').toggleClass('active');
            });

            // close mobile menu
            $('.UIHeader .close-btn').off('click').on('click',function(e) {
                e && e.preventDefault();
                $('.UIHeader').removeClass('active');
            });

        }

        function markActiveMenu() {
            $('.UIHeader nav a').removeClass('active');
            if (window.location.pathname != '/') {
                $('.UIHeader nav a').each(function() {
                    if (window.location.pathname.indexOf($(this).attr('href'))!=-1) {
                        $(this).addClass('active');
                    }
                });
            }
        }

    }

    function homeController() {

        (function() {
            events();
        }());

        function events() {

            // play KV video
            $('.UIHome .keyvisual .expand').off('click.wbshck').on('click.wbshck',function(e) {
                e && e.preventDefault();
                playYoutubeInLightbox($(this));
            });

            // play video
            $('.UIHome .welcome .play').off('click.wbshck').on('click.wbshck',function(e) {
                e && e.preventDefault();
                playYoutubeInLightbox($(this));
            });

            // play youtube
            $('.UIHome .howto .play').off('click.wbshck').on('click.wbshck',function(e) {
                e && e.preventDefault();
                playYoutubeInLightbox($(this));
            });

            // stop video
            $root.find('.lightbox .btn.close').off('click.wbshck').on('click.wbshck',function(e) {
                e && e.preventDefault();
                closeVideoInLightbox();
            });
        }

        function closeVideoInLightbox() {
            if ($root.find('.lightbox video') && $root.find('.lightbox video')[0]) {
                $root.find('.lightbox video')[0].pause();
            }
            $root.find('.lightbox').remove();
        };

        function playKVVideoInLightbox(video) {

            var $lightbox = $(''+
                    '<div class="lightbox">'+
                        '<a href="/" class="btn close"><i></i><i></i></a>'+
                        '<video src="'+ video +'" autoplay controls></video>'+
                        // '<div class="youtube"><iframe src="https://www.youtube.com/embed/zHBRFVtEySQ?&autoplay=1&showinfo=0" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>'+
                    '</div>'+
                '');

            $root.find('.lightbox').remove();
            $root.append($lightbox);
            events();

        }

        function playVideoInLightbox($btn) {

            var video = $btn.attr('href'),
                $lightbox = $(''+
                    '<div class="lightbox">'+
                        '<a href="/" class="btn close"><i></i><i></i></a>'+
                        '<video src="'+ video +'" autoplay controls></video>'+
                        // '<div class="youtube"><iframe src="https://www.youtube.com/embed/zHBRFVtEySQ?&autoplay=1&showinfo=0" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>'+
                    '</div>'+
                '');

            $root.find('.lightbox').remove();
            $root.append($lightbox);
            events();

        }

        function playYoutubeInLightbox($btn) {

            var video_id = $btn.data('id'),
                $lightbox;

            if (!video_id) video_id = getYoutubeIdFromUrl($btn.attr('href'));

            $lightbox = $(''+
                    '<div class="lightbox">'+
                        '<a href="/" class="btn close"><i></i><i></i></a>'+
                        '<div class="youtube"><iframe src="https://www.youtube.com/embed/'+video_id+'?&autoplay=1&showinfo=0" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>'+
                    '</div>'+
                '');

            $root.find('.lightbox').remove();
            $root.append($lightbox);
            events();

        }

    }

    function heroesController() {

        var $heroes = $('.UIHeroes'),
            $slider = $heroes.find('.slider'),
            numOfSlides = 35, // odd number
            sliderWidth = 0,
            dragDeltaX = 0,
            startDeltaX = 0,
            dragging = false,
            preloadTO = false;

        (function() {
            preload3rdHero();
            events();
        }());

        function events() {

            // on load
            $(window).load(function(e) {
                duplicateSlides();
                resizeHeroesSlider();
                initHeroesPosition();
                markInitalHero();
                setTimeout(preloadContent,2000);
            });

            // on resize
            $(window).resize(function(e) {
                resizeHeroesSlider();
            });

            // handle hover
            $heroes.find('.carousel .hero').off('mouseenter.wbshck').on('mouseenter.wbshck',function(e) {
                $(this).addClass('hover');
            });
            $heroes.find('.carousel .hero').off('mouseleave.wbshck').on('mouseleave.wbshck',function(e) {
                $(this).removeClass('hover');
            });

            // hightlight a hero
            $heroes.find('.carousel .hero').off('click.wbshck').on('click.wbshck',function(e) {
                e && e.preventDefault();
                // if it didn't moved
                if (dragDeltaX == e.clientX) {
                    selectHero($(this),e);
                }
            });

            // start dragging heroes
            $heroes.find('.carousel').off('mousedown.wbshck touchstart.wbshck').on('mousedown.wbshck touchstart.wbshck',function(e){
                e && e.preventDefault();
                startDraggingHeroes(e);
            });

            // stop dragging heroes
            $(document).off('mouseup.wbshck touchend.wbshck touchcancel.wbshck').on('mouseup.wbshck touchend.wbshck touchcancel.wbshck',function(e) {
                // e && e.preventDefault();
                var eX = e.clientX || e.originalEvent.changedTouches[0].clientX;
                if (dragDeltaX == eX) {
                    dragging = false;
                    selectHero($(e.target).closest('.hero'),e);
                }
                else {
                    stopDraggingHeroes(e);
                }
            });

            // drag heroes
            $(document).off('mousemove.wbshck touchmove.wbshck').on('mousemove.wbshck touchmove.wbshck',function(e) {
                dragHeroes(e);
            });

            // next / prev
            $heroes.find('.details .btn').off('click.wbshck touchend.wbshck').on('click.wbshck touchend.wbshck',function(e) {
                e && e.preventDefault();
                ($(this).hasClass('next')) ? changeHero(1) : changeHero(-1);
            });

        }

        function changeHero(dir) {
            if (dragging) return;

            var $hero = $heroes.find('.carousel .hero.active'),
                $slide = $hero.closest('.slide'),
                max = $slide.find('.hero').length,
                idx = $slide.find('.hero').index($hero);

            idx += dir;
            if (idx >= max) {
                idx = 0;
                $slide = $slide.next()
            };
            if (idx < 0) {
                idx == max;
                $slide = $slide.prev()
            };

            $hero = $slide.find('.hero:eq('+idx+')');
            selectHero($hero);

        }

        function duplicateSlides() {

            var $slide = $slider.find('.slide');

            for (var i=0; i < (numOfSlides-1); i++) {
                $slider.append($slide.clone());
            }

            events();
        }

        function initHeroesPosition() {
            var initHeroesX = 0,
                slideWidth = $slider.find('.slide:eq(0)').width();

            tw.set($slider,{x:(initHeroesX - (slideWidth * (Math.floor(numOfSlides/2))))});

        }

        function markInitalHero() {
            $slider.find('.hero').removeClass('active hover');
            $slider.find('.slide:eq('+(Math.floor(numOfSlides/2))+') .hero:eq(2)').addClass('active');
            changeHeroDescripton();
        }

        function resizeHeroesSlider() {
            sliderWidth = $heroes.find('.slider .slide').width() * numOfSlides;
            $slider.width(sliderWidth);
        }

        function selectHero($hero,e) {

            var heroWidth = $slider.find('.hero:eq(0)').width(),
                sliderX = $slider[0]._gsTransform ? $slider[0]._gsTransform.x : 0,
                maxNegativeX = -1 * (sliderWidth - $heroes.width()),
                curr3rdSlotHeroIndex = -1 * $heroes.find('.hero').index($hero);

            if (dragging) return;

            $heroes.find('.hero').removeClass('active hover');
            $hero.addClass('active');

            // handle edges
            sliderX = ((curr3rdSlotHeroIndex+2)*heroWidth);
            (sliderX <= maxNegativeX) && (sliderX = maxNegativeX);
            (sliderX >= 0) && (sliderX = 0);

            tw.to($slider,0.3,{x:sliderX});

            resizeHeroesSlider();
            changeHeroDescripton();

        }

        function startDraggingHeroes(e) {
            dragging = true;
            dragDeltaX = e.clientX || e.originalEvent.touches[0].clientX,
            startDeltaX = $slider[0]._gsTransform ? $slider[0]._gsTransform.x : 0;
            $heroes.find('.hero').removeClass('active hover');
        }

        function stopDraggingHeroes(e) {
            if (dragging) {
                dragging = false;
                snapClosestHeroToThirdSlot();
            }
        }

        function snapClosestHeroToThirdSlot() {
            var heroWidth = $slider.find('.hero:eq(0)').width(),
                sliderX = $slider[0]._gsTransform ? $slider[0]._gsTransform.x : 0,
                curr3rdSlotHeroIndex = Math.floor((sliderX-(2*heroWidth)+(heroWidth/1.5)) / heroWidth),
                maxNegativeX = -1 * (sliderWidth - $heroes.width());

            $heroes.find('.hero').removeClass('active hover');
            $heroes.find('.hero:eq('+Math.abs(curr3rdSlotHeroIndex)+')').addClass('active');

            // handle edges
            sliderX = ((curr3rdSlotHeroIndex+2)*heroWidth);
            (sliderX <= maxNegativeX) && (sliderX = maxNegativeX);
            (sliderX >= 0) && (sliderX = 0);

            tw.to($slider,0.3,{x:sliderX});

            changeHeroDescripton();

        }

        function dragHeroes(e) {

            var clientX = e.clientX || e.originalEvent.touches[0].clientX,
                sliderX = startDeltaX - (1 * (dragDeltaX - clientX)),
                maxNegativeX = -1 * (sliderWidth - $heroes.width());

            if (!dragging) return;

            $heroes.find('.hero').removeClass('active hover');

            // handle edges
            (sliderX <= maxNegativeX) && (sliderX = maxNegativeX);
            (sliderX >= 0) && (sliderX = 0);

            tw.set($slider,{x: sliderX});

            highlight3rdHero();

        }

        function highlight3rdHero() {
            var heroWidth = $slider.find('.hero:eq(0)').width(),
                sliderX = $slider[0]._gsTransform ? $slider[0]._gsTransform.x : 0,
                curr3rdSlotHeroIndex = Math.floor((sliderX-(2*heroWidth)+(heroWidth/1.5)) / heroWidth);

            $heroes.find('.hero').removeClass('active hover');
            $heroes.find('.hero:eq('+Math.abs(curr3rdSlotHeroIndex)+')').addClass('active');

        }

        function preload3rdHero() {
            // console.log('preload3rdHero');
            loadDelayedGraphics($heroes.find('.details .hero-item:eq(2) [delay-src]'));
            loadDelayedGraphics($heroes.find('.component .component-wrap:eq(2) [delay-src]'));
        }

        function preloadContent() {
            preloadTO = setInterval(function() {
                // console.log('preloadContent:', $heroes.find('[delay-src]').length);
                if($heroes.find('[delay-src]') && $heroes.find('[delay-src]').length > 0) {
                    loadDelayedGraphics($heroes.find('[delay-src]').slice(0,10));
                }
                else {
                    clearInterval(preloadTO);
                }
            },2000);
        }

        function changeHeroDescripton() {

            var $activeHero = $slider.find('.hero.active'),
                idx = $activeHero.closest('.slide').find('.hero').index($activeHero),
                nextTO = 1000, prevTO = 2000;

            // hide preloader
            $('.preloader').hide();

            // change description
            $heroes.find('.details .hero-item').removeClass('active');
            $heroes.find('.details .hero-item:eq('+idx+')').addClass('active');
            loadDelayedGraphics($heroes.find('.details .hero-item:eq('+idx+')').find('img, video'));
            setTimeout(function(){
                loadDelayedGraphics($heroes.find('.details .hero-item:eq('+(idx+1)+')').find('img, video'));
            },nextTO);
            setTimeout(function(){
                loadDelayedGraphics($heroes.find('.details .hero-item:eq('+(idx-1)+')').find('img, video'));
            },prevTO);



            // change components
            $heroes.find('.component .component-wrap').removeClass('active');
            $heroes.find('.component .component-wrap:eq('+idx+')').addClass('active');
            loadDelayedGraphics($heroes.find('.component .component-wrap:eq('+idx+')').find('img, video'));
            setTimeout(function(){
                loadDelayedGraphics($heroes.find('.component .component-wrap:eq('+(idx+1)+')').find('img, video'));
            },nextTO);
            setTimeout(function(){
                loadDelayedGraphics($heroes.find('.component .component-wrap:eq('+(idx-1)+')').find('img, video'));
            },prevTO);


            // change related products
            $heroes.find('.buy .buy-wrap').removeClass('active');
            $heroes.find('.buy .buy-wrap:eq('+idx+')').addClass('active');
            loadDelayedGraphics($heroes.find('.buy .buy-wrap:eq('+idx+')').find('img, video'));
            setTimeout(function(){
                loadDelayedGraphics($heroes.find('.buy .buy-wrap:eq('+(idx+1)+')').find('img, video'));
            },nextTO);
            setTimeout(function(){
                loadDelayedGraphics($heroes.find('.buy .buy-wrap:eq('+(idx-1)+')').find('img, video'));
            },prevTO);

            // change FAQs
            $heroes.find('.faq .faq-wrap').removeClass('active');
            $heroes.find('.faq .faq-wrap:eq('+idx+')').addClass('active');

        }

    }

    function faqController() {

        (function() {
            events();
        }());

        function events() {

            // downloads filter
            $root.find('.UIAux.faq .downloads .filters a').off('click.wbshck').on('click.wbshck',function(e) {
                e && e.preventDefault();
                filterDownloads($(this));
            });


        }

        function filterDownloads($filter) {
            $root.find('.UIAux.faq .downloads .filters a').removeClass('active');
            $filter.addClass('active');
            $root.find('.UIAux.faq .downloads .links a').removeClass('last').hide();
            if ($filter.data('tag')=='all') {
                $root.find('.UIAux.faq .downloads .links a').removeClass('last').show();
            }
            else if ($filter.data('tag')=='latest') {
                $root.find('.UIAux.faq .downloads .links a').slice(0,4).show().last().addClass('last');
            }
            else {
                $root.find('.UIAux.faq .downloads .links a').hide().each(function() {
                    ($(this).data('tags') && $(this).data('tags').indexOf($filter.data('tag'))!=-1) && $(this).show();
                });
                $root.find('.UIAux.faq .downloads .links a:visible').last().addClass('last');
            }
        }


    }

    function productController() {

        var gallery = {
            currIndex: 0,
            numOfGalleryImages: 0,
            images: []
        };

        (function() {
            formatMoney();
            hideUpsell();
            // preorderCountdown(); // handled with inline javascript product.liquid
            events();
            if (customer && customer.email=='nexus6.nexus6+1@gmail.com') renderBundle();
        }());

        function events() {

            // show gallery
            $root.find('.UIProduct .extra-images .gallery .img, .UIProduct .features .gallery .img').off('click.wbshck').on('click.wbshck',function(e) {
                e && e.preventDefault();
                openImageInLightboxGallery($(this));
            });

            // prev/next gallery
            $root.find('.lightbox .btn.pager').off('click.wbshck').on('click.wbshck',function(e) {
                e && e.preventDefault();
                changeImageInLightboxGallery($(this));
            });

            // play video
            $root.find('.UIProduct .btn.play').off('click.wbshck').on('click.wbshck',function(e) {
                e && e.preventDefault();
                openVideoPlayerInLightbox($(this));
            });

            // close lightbox
            $root.find('.lightbox .btn.close').off('click.wbshck').on('click.wbshck',function(e) {
                e && e.preventDefault();
                closeLightbox();
            });

            // submenu
            $root.find('.UIProduct .nav a').off('click.wbshck').on('click.wbshck',function(e) {
                // e && e.preventDefault();
                // moveToSection(sectionId);
            });

            // downloads filter
            $root.find('.UIProduct .downloads .filters a').off('click.wbshck').on('click.wbshck',function(e) {
                e && e.preventDefault();
                filterDownloads($(this));
            });

            // variant select
            $root.find('.UIProduct #productSelect').off('change.wbshck').on('change.wbshck',function(e) {
                $root.find('.UIProduct .features .sku, .UIProduct .keyvisual h3').removeClass('active');
                $root.find('.UIProduct .features .sku[data-id="'+ $(this).val() +'"], .UIProduct .keyvisual h3[data-id="'+ $(this).val() +'"]').addClass('active');
            });

            $root.find('.UIProduct button[name="add"]').off('click.wbshck').on('click.wbshck',function(e) {

                if (
                    $('.variant_selector #productSelect').length > 0 &&
                    $('.variant_selector #productSelect')[0].selectedIndex <= 0
                ) {
                    e && e.preventDefault();
                    alert('Please select a product variant.');
                    return;
                }

                if (
                    $(this).data('preorder')==1
                    // !confirm('This item is a PREORDER. You will be charged for this product now. Orders that contain a PREORDER item will not ship until all items are available. In-stock items will not ship separately, and orders cannot be split after being placed.')
                ) {
                    e && e.preventDefault();

                    $('#shopify-error-popup').simpleConfirm({
                      message: $("#popup-message-content").text(),
                      title: "",
                      acceptLabel: "By selecting this, you agree to the above terms related to preorder products",
                      success: function(e){$('#AddToCartForm').submit()},
                      cancel: function(){location.reload()}
                    });
                    return;

                }

            });

            // variants images
            $root.find('.UIProduct .variant_selector select').off('change.wbshck').on('change.wbshck',function(e) {
                $root.find('.UIProduct .variant_selector img').removeClass('active');
                $root.find('.UIProduct .variant_selector img.variant-id-'+$(this).val()).addClass('active');
            });

            // show gallery
            $root.find('.UIProduct .variant_selector .variant_images img').off('click.wbshck').on('click.wbshck',function(e) {
                e && e.preventDefault();
                openVariantImageInLightboxGallery($(this));
            });

        }

        function hideUpsell() {
            if ($('.upsell .col.left').length == 0) {
                $('.upsell').hide();
            }
        }

        function filterDownloads($filter) {
            $root.find('.UIProduct .downloads .filters a').removeClass('active');
            $filter.addClass('active');
            $root.find('.UIProduct .downloads .links a').removeClass('last').hide();
            if ($filter.data('tag')=='all') {
                $root.find('.UIProduct .downloads .links a').removeClass('last').show();
            }
            else if ($filter.data('tag')=='latest') {
                $root.find('.UIProduct .downloads .links a').slice(0,4).show().last().addClass('last');
            }
            else {
                $root.find('.UIProduct .downloads .links a').hide().each(function() {
                    ($(this).data('tags') && $(this).data('tags').indexOf($filter.data('tag'))!=-1) && $(this).show();
                });
                $root.find('.UIProduct .downloads .links a:visible').last().addClass('last');
            }
        }

        function closeLightbox() {
            $root.find('.lightbox').remove();
        }

        function changeImageInLightboxGallery($btn) {

            var $lightbox = $root.find('.lightbox.gallery'),
                direction = $btn.hasClass('next') ? 'next' : 'prev';


            if ($lightbox.length < 1) return;


            if (direction == 'next') {
                gallery.currIndex ++;
                if (gallery.currIndex >= gallery.numOfGalleryImages) gallery.currIndex = 0;
            }
            else {
                gallery.currIndex --;
                if (gallery.currIndex < 0) gallery.currIndex = gallery.numOfGalleryImages-1;
            }

            // console.log(gallery.currIndex);

            $lightbox.find('.image img').attr('src',gallery.images[gallery.currIndex].src);
            $lightbox.find('.label .currIndex').text(gallery.currIndex+1);

        }

        function openVariantImageInLightboxGallery($btn) {
            var url = $btn.data('src'),
                $lightbox = $(''+
                    '<div class="lightbox gallery">'+
                        '<a class="btn close"><i></i><i></i></a>'+
                        '<div class="image"></div>'+
                    '</div>'+
                '');

                $lightbox.find('.image').append('<img src="'+url+'">');
                $root.append($lightbox);
                events();

        }

        function openImageInLightboxGallery($btn) {

            var url = $btn.data('src'),
                numOfGalleryImages = $btn.closest('.gallery').data('gallery_num'),
                currIndex = parseInt($btn.data('index'),10)-1,
                $lightbox = $(''+
                    '<div class="lightbox gallery">'+
                        '<a class="btn close"><i></i><i></i></a>'+
                        '<a class="btn pager prev"><i></i><i></i></a>'+
                        '<a class="btn pager next"><i></i><i></i></a>'+
                        '<div class="image"></div>'+
                        '<div class="label"><b class="currIndex">'+(currIndex+1)+'</b>/<b class="numOfGalleryImages">'+numOfGalleryImages+'</b></div>'+
                    '</div>'+
                ''),
                tempImages=[];

            gallery.numOfGalleryImages = numOfGalleryImages;
            gallery.currIndex = currIndex;

            $root.find('.UIProduct .gallery .img').each(function() {
                if ($(this).data('index') && $(this).data('src')) {
                    tempImages.push({
                        src: $(this).data('src'),
                        index: parseInt($(this).data('index'),10)-1
                    })
                }
            })
            gallery.images = tempImages;

            function propComparator(prop) {
                return function(a, b) {
                    return a[prop] - b[prop];
                }
            }

            gallery.images.sort(propComparator('index'));

            $root.append($lightbox);
            $lightbox.find('.image').append('<img src="'+url+'">')
            events();
        }

        function openVideoPlayerInLightbox($btn) {
            var url = $btn.data('src'),
                $lightbox = $(''+
                    '<div class="lightbox video">'+
                        '<a class="btn close"><i></i><i></i></a>'+
                        '<div class="youtube"></div>'+
                    '</div>'+
                '');

            $root.append($lightbox);
            $lightbox.find('.youtube').append('<iframe width="560" height="315" src="//www.youtube.com/embed/'+getYoutubeIdFromUrl(url)+'?autoplay=1&related=0" frameborder="0" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe>')
            events();
        }

        function preorderCountdown() {
            var $countDown = $root.find('.preorder .countdown'),
                $days = $countDown.find('.days b'),
                $hours = $countDown.find('.hours b'),
                $minutes = $countDown.find('.minutes b'),
                $seconds = $countDown.find('.seconds b'),
                countDownDate = new Date($countDown.data('release-date'));

            // var countDownDate = new Date("Jan 5, 2021 15:37:25").getTime();

            // Update the count down every 1 second
            var x = setInterval(tick, 1000);
            function tick() {

                // Get today's date and time
                var now = new Date().getTime();

                // Find the distance between now and the count down date
                var distance = countDownDate - now;

                // Time calculations for days, hours, minutes and seconds
                var days = Math.floor(distance / (1000 * 60 * 60 * 24));
                var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                var seconds = Math.floor((distance % (1000 * 60)) / 1000);

                // If the count down is finished, write some text
                if (distance < 0) {
                    clearInterval(x);
                    $days.text(0);
                    $hours.text(0);
                    $minutes.text(0);
                    $seconds.text(0);
                }
                else {
                    // console.log(days + 'd ' + hours + 'h ' + minutes + 'm ' + seconds + 's ');
                    $days.text(days);
                    $hours.text(hours);
                    $minutes.text(minutes);
                    $seconds.text(seconds);
                }

            }

        }

        function formatMoney() {
            var $prices = $('.UIProduct .sku i'),
                $options = $('.UIProduct #productSelect option'),
                currencyCode = $('.UIHeader .currency').data('currency')

            $prices.each(function() {
                var $price = $(this),
                    priceInCents = $price.data('price'),
                    currencySymbol = $price.data('currency'),
                    priceFormattedAndRounded = 0;

                if (priceInCents) {
                    priceFormattedAndRounded = Math.round(priceInCents / 100);
                    // console.log(priceInCents,priceFormattedAndRounded);
                    $price.html(currencySymbol+''+priceFormattedAndRounded+' <u>'+ currencyCode +'</u>');
                }

            });

            $options.each(function() {
                var $option = $(this),
                    priceInCents = $option.data('price'),
                    currencySymbol = $option.data('currency'),
                    variantTitle = $option.data('variant-title'),
                    priceFormattedAndRounded = 0;

                if (priceInCents) {
                    priceFormattedAndRounded = Math.round(priceInCents / 100);
                    // console.log(priceInCents,priceFormattedAndRounded);
                    $option.text(variantTitle+' - '+currencySymbol+''+priceFormattedAndRounded+' '+ currencyCode +'');
                }

            });

            // addons price
            $('.UIProduct .upsell .addon').each(function() {
                var $sku = $(this).find('.sku');
                var symbol = $sku.data('currency');
                var price = $(this).find('.sku span').text();
                var currencyCode = $('.UIHeader .currency').data('currency')
                price = price.replace('.00','');
                $(this).find('.sku b').text(symbol);
                $(this).find('.sku span').text(price);
                $(this).find('.sku u').text(currencyCode);
            });

        }

        function renderBundle() {

            // exit if no bold app
            if (!product || $('#shappify_bundle').length < 1) return;
            // console.log('product',product);


            var $thumb = $('.slider .thumb:eq(0)').clone(),
                currencyCode = $('.UIHeader .currency').data('currency'),
                currencySymbol = $('.bundle').data('currency'),
                resizeTO;

            // init
            (function() {
                clearTemplate();
                fetchBundleData();
            }());

            function clearTemplate() {
                $('.bold-bundle-widget').hide();
                $('.bundle').hide();
                $('.bundle .contains li').remove();
                $('.bundle .slider .thumb').remove();
            }

            function fetchBundleData() {
                $.get('https://bundles.boldapps.net/v2/dice-throne-store.myshopify.com/product/'+ product.id +'/bundles',function(data) {
                    var bundle;
                    // data.member_bundles = null;
                    if (data && data.member_bundles && Array.isArray(data.member_bundles) && data.member_bundles.length > 0) {
                        bundle = data.member_bundles[0];
                        if (bundle && Array.isArray(bundle.products) && bundle.products.length > 0) {
                            renderBundleWrapper(bundle);
                            _.each(bundle.products,function(item) {
                                var product = item;
                                $.getJSON('/products/'+ item.handle +'.js',function(itemData) {
                                    product.orig = itemData;
                                    $.get('/collections/all/products/'+ item.handle +'',function(itemData) {
                                        product.metafields = JSON.parse($(itemData).find('#product-metafields').html());
                                        renderBundleProduct(product);
                                    });
                                });
                            });
                        }
                    }
                    else {
                        $('.upsell').addClass('no-bundle');
                    }
                });
            }

            function _events() {

                $(window).resize(function() {
                    clearTimeout(resizeTo);
                    resizeTo = setTimeout(handleBundleProductsSlider,500);
                });

                $('.bundle .btn.add-bundle-to-cart').off('click').on('click',function(e){
                    e && e.preventDefault();
                    // submit via original widget
                    $('.btn.bold-bundles-widget__button').trigger('click');
                });

                $('.bundle .prev').off('click').on('click',function(e) {
                    e && e.preventDefault();
                    moveSliderForOneThumb('left');
                });

                $('.bundle .next').off('click').on('click',function(e) {
                    e && e.preventDefault();
                    moveSliderForOneThumb('right');
                });

            }

            function moveSliderForOneThumb(direction) {

                var dir = ((direction=='left') ? -1 : 1),
                    $slider = $('.bundle .slider'),
                    $wrapper = $('.bundle .wrapper'),
                    step = $('.bundle .slider .thumb:eq(0)').width(),
                    diffX = $slider.width() - $wrapper.width(),
                    minX = ((diffX > 0) ? -diffX : 0),
                    maxX = 0;


                // console.log(minX,maxX);
                tw.to($slider,.5,{x: '+='+(dir*step), onUpdate:limit, onUpdateParams:[minX,maxX]});

                function limit(mn,mx){
                    var T=this.target , elT=T[0]._gsTransform;
                    if( elT.x<mn || elT.x>mx ){ TweenLite.set(T,{ x:elT.x>mx?mx:mn }) };
                };

            }

            function handleBundleProductsSlider() {

                // console.log('handleBundleProductsSlider');

                var $slider = $('.bundle .slider'),
                    $wrapper = $('.bundle .wrapper'),
                    $products = $slider.find('.thumb'),
                    productsWidth = 0;

                // measure and set slider width
                $products.each(function() {
                    productsWidth += $(this).width();
                });
                $slider.width(productsWidth+20);

                // toggle prevnext
                ($slider.width() > $wrapper.width()) ? $('.bundle .prevnext').show() : $('.bundle .prevnext').hide();

                // reset events
                _events();


            }

            function renderBundleWrapper(bundle){

                // console.log('bundle',bundle);

                bundle.old_price = (getOldPrice(bundle) * 100);
                bundle.new_price = (bundle.total * 100);
                bundle.save = bundle.old_price - bundle.new_price;

                $('.bundle h3').text(bundle.name);
                $('.bundle p').text(bundle.message_title);

                $('.bundle .sku > b').text(currencySymbol);
                $('.bundle .currency-code').text(currencyCode);
                $('.bundle .sku.orig > span').text(roundMoney(bundle.old_price / 100));
                $('.bundle .sku.new > span').text(roundMoney(bundle.new_price / 100));
                $('.bundle .sku.new .save').text(roundMoney(bundle.save / 100));

                $('.bundle').show().css({'display':'flex'});
                $('.upsell').show().css({'display':'flex'});
                // $('.bold-bundle-widget').show().css({'display':'flex'});

                _events();

            }

            function renderBundleProduct(bundleProduct){

                // console.log('bundleProduct',bundleProduct);

                var $t = $thumb.clone(),
                    bundleProductName = bundleProduct.name || '';

                bundleProductName = bundleProductName.replace(/<br>/g,' ');

                $t.find('a.photo').attr('href','/collections/all/products/'+bundleProduct.handle);
                $t.find('.img').attr('src',bundleProduct.metafields.metafields.custom_fields.product_thumbnail_3d).attr('title',bundleProductName);
                $('.bundle .slider').append($t);

                $('.bundle .contains ul').append($('<li>'+bundleProductName+'</li>'));

                handleBundleProductsSlider();
                _events();

            }

            function getNewPriceInSelectedCurrency(bundle) {
                var out = 0;
                if (bundle && bundle.products) {
                    _.each(bundle.products,function(prod) {
                        out += prod.orig.price
                    });
                }
                out = out - (out * (bundle.percent/100));
                return out;
            }

            function getOldPrice(bundle) {
                var out = 0;
                if (bundle && bundle.products) {
                    _.each(bundle.products,function(prod) {
                        out += prod.old_price
                    });
                }
                return out;
            }

            function getOldPriceInSelectedCurrency(bundle) {
                var out = 0;
                if (bundle && bundle.products) {
                    _.each(bundle.products,function(prod) {
                        out += prod.orig.price
                    });
                }
                return out;
            }

        }

    }

    function addressesController() {

        // init
        (function() {
            input();
            events();
        }());

        function input() {
            var $countrySelectors = $root.find('.address-item select[name="address[country]"]');

            $countrySelectors.each(function() {
                var $country = $(this),
                    $group = $country.closest('.group'),
                    $province = $country.siblings('select[name="address[province]"]'),
                    country = $group.data('country'),
                    province = $group.data('province');

                $country.find('option[value="'+ country +'"]').prop('selected','selected');

                if (province && $province.length < 1) {
                    renderProvinces($country.find('option[value="'+ country +'"]'));
                    $province = $country.siblings('select[name="address[province]"]');
                }
                $province.find('option[value="'+ province +'"]').prop('selected','selected');

            })
        }

        function events() {

            // show provinces on country select
            $root.find('select[name="address[country]"]').off('change').on('change',function(e) {
                var $selectedOption = $(this).find('option:eq('+$(this)[0].selectedIndex+')');
                renderProvinces($selectedOption);
            });

            // default address
            $root.find('.btn.default').off('click').on('click',function(e) {
                e && e.preventDefault();
                makeDefaultAddressandSave($(this).closest('.address-item'));
            })

        }

        function makeDefaultAddressandSave($address) {
            var addressId = $address.data('address_id'),
                defaultAddressId = $address.data('default_address_id'),
                $form = $address.find('form');

            // console.log($form, defaultAddressId, addressId);

            $form.attr('action','/account/addresses/'+defaultAddressId);
            $form.attr('id','address_form_'+defaultAddressId);
            $form[0].submit();
        }

        function renderProvinces($option) {
            var provinces = $option.data('provinces'),
                $provinces = $('<select name="address[province]"></select>');

            $option.closest('.group').find('select[name="address[province]"]').remove();
            if (!provinces || provinces.length < 1) return;

            $provinces.append('<option disabled selected>Province</option>')
            for (var i=0; i < provinces.length; i++) {
                $provinces.append('<option value="'+ provinces[i][0] +'">'+ provinces[i][0] +'</option>')
            }
            $option.closest('select').after($provinces)
        }

    }

    function accountController() {

        // init
        (function() {
            // console.log('accountController');
            inputs();
            events();
            scrollToErrorMsg();
        }());

        function inputs() {

            // show recover password form
            console.log(window.location.hash);
            if (window.location.hash=='#recover') {
                showRecoverPasswordForm();
            }

        }

        function events() {

            // show recover password form
            $root.find('.forgot a').off('click').on('click',function(e) {
                e && e.preventDefault();
                showRecoverPasswordForm();
            });

            // edit address
            $root.find('.btn.new').off('click').on('click',function(e) {
                e && e.preventDefault();
                var $form = $(this).closest('.col.new').find('.edit-form');
                $form.show();
                $(this).hide();
            });

            // edit address
            $root.find('.btn.edit').off('click').on('click',function(e) {
                e && e.preventDefault();
                var $form = $(this).closest('.address-item').find('.edit-form');
                var $details = $(this).closest('.address-item').find('.details');
                $details.hide();
                $form.show();
            });

            // cancel edit address
            $root.find('.btn.cancel').off('click').on('click',function(e) {
                e && e.preventDefault();
                var $form = $(this).closest('.address-item, .col.new').find('.edit-form');
                var $details = $(this).closest('.address-item').find('.details');
                var $btnnew = $(this).closest('.col.new').find('.btn.new');
                $details.show();
                $btnnew.show();
                $form.hide();
            });

            // delete address
            $root.find('.btn.delete').off('click').on('click',function(e) {
                // console.log('delete..');
                if (!confirm('Are you sure you want to delete this address?')) {
                    e && e.preventDefault();
                }
            });

            // save address
            $root.find('.btn.save').off('click').on('click',function(e) {
                // e && e.preventDefault();
                // console.log('save..');
            });

        }

        function showRecoverPasswordForm() {
            $root.find('.signin').hide();
            $root.find('.recover').show();
        }

        function scrollToErrorMsg() {
            if ($root.find('form .errors').length > 0) {
                console.log('scrollToErrorMsg');
                $('html, body').animate({
                    scrollTop: $root.find('form .errors:eq(0)').offset().top - 100
                }, 500);
            }
        }

    }

    function collectionController() {

        var scrollTO=false;

        (function() {
            input();
            formatMoney();
            buildTagsFilters();
            events();
            explodeKeyvisualH2Letters();
            hideEmptyCategories();
            showMoreProductsBelowNotification();
        }());

        function events() {

            // show more products notif on scroll
            $(window).on('resize', function() {
                clearTimeout(scrollTO);
                scrollTO = setTimeout(function(){
                    showMoreProductsBelowNotification();
                },100);
            });

            // select click default
            $root.find('.filters .btn.down').off('click.wbshck').on('click.wbshck',function(e) {
                e && e.preventDefault();
            });

            // custom select click default
            $root.find('.filters .select .btn.down, .filters .select .selected').off('click.wbshck').on('click.wbshck',function(e) {
                e && e.preventDefault();
                if (touch) {
                    // $('.filters .select').removeClass('active');
                    $(this).closest('.select').toggleClass('active');
                }
            });

            // filter
            $root.find('.filters select[name="tags"]').off('change.wbshck').on('change.wbshck',function(e) {
                filterProductsByTag();
            });

            // collections
            $root.find('.filters select[name="collections"]').off('change.wbshck').on('change.wbshck',function(e) {
                window.location.href = $(this).val();
            });

            // sort
            $root.find('.filters select[name="sort"]').off('change.wbshck').on('change.wbshck',function(e) {
                sortProducts($(this));
            });
            // sort on custom select
            $root.find('.filters .select.sort .unselected .option').off('click.wbshck').on('click.wbshck',function(e) {
                sortProductsOnCustomSelect($(this));
            });

        }

        function input() {
            var qp = getQueryParams(window.location.search),
                sortBy = qp.sort_by; // $root.find('.filters select[name="sort"]').data('value');
            // console.log(sortBy);
            if (sortBy) {
                $root.find('.filters select[name="sort"]').val(sortBy);
                $root.find('.filters .select.sort .selected').data('value',sortBy);
                $root.find('.filters .select.sort .selected').text($root.find('.filters .select.sort .unselected .option[data-value="'+sortBy+'"]').text());
                (sortBy.indexOf('released')!=-1) && (sortByReleased(sortBy));
            }

            // select filter
            $root.find('.filters select[name="collections"] option').each(function() {
                if (window.location.href.indexOf($(this).val())!=-1) {
                    console.log($(this).val());
                     $(this).prop('selected',true);
                }
            });

        }

        function showMoreProductsBelowNotification() {

            var ww = $(window).width();

            $('.products:visible:not(:last-child)').each(function() {

                var itemsPerLine = 1,
                    $products = $(this),
                    numOfItems = $products.find('.product').length,
                    modulo = 0;

                if(ww < 410) {
                    itemsPerLine = 1;
                }
                else if(ww < 600) {
                    itemsPerLine = 2;
                }
                else if (ww < 768) {
                    itemsPerLine = 3;
                }
                else {
                    itemsPerLine = 4;
                }

                modulo = numOfItems % itemsPerLine;
                // console.log(numOfItems +' % '+ itemsPerLine +' = '+ modulo );

                $products.find('.more').removeClass('active');
                if (modulo > 0) {
                    $(this).find('.more').addClass('active');
                    $(this).find('.more').off('click').on('click',function(e) {
                        e && e.preventDefault();
                        var $next = $products.next('.products');
                        if ($next.length > 0) {
                            $('html, body').animate({scrollTop: ($next.offset().top-150)},500);
                        }
                    });
                }


            });
        }

        function sortByReleased(sortBy) {
            // console.log('sortByReleased',sortBy);
            if (sortBy=='released-ascending') {
                $('.grid .product').sort(function(a,b) {
                    var av = parseInt($(a).data('released'),10) || 0,
                        bv = parseInt($(b).data('released'),10) || 0;
                    // console.log(av,bv);
                    return av - bv;
                }).appendTo('.grid');
            }
            else {
                $('.grid .product').sort(function(a,b) {
                    var av = parseInt($(a).data('released'),10) || 0,
                        bv = parseInt($(b).data('released'),10) || 0;
                    // console.log(av,bv);
                    return bv - av;
                }).appendTo('.grid');
            }
        }

        function sortProductsOnCustomSelect($this) {
            // console.log('sortProducts');
            Shopify.queryParams = {};
            if (location.search.length) {
                for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
                    aKeyValue = aCouples[i].split('=');
                    if (aKeyValue.length > 1) {
                        Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
                    }
                }
            }
            Shopify.queryParams.sort_by = $this.data('value');
            location.search = $.param(Shopify.queryParams).replace(/\+/g, '%20');
        }

        function sortProducts($this) {
            // console.log('sortProducts');
            Shopify.queryParams = {};
            if (location.search.length) {
                for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
                    aKeyValue = aCouples[i].split('=');
                    if (aKeyValue.length > 1) {
                        Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
                    }
                }
            }
            Shopify.queryParams.sort_by = $this.val();
            location.search = $.param(Shopify.queryParams).replace(/\+/g, '%20');
        }

        function filterProductsByTag() {
            // console.log('filterProductsByTag');

            var tag = $root.find('.filters select[name="tags"]').val();

            $root.find('.products').show();
            $root.find('.product').show();
            if (tag!='all') {
                $root.find('.product').hide();
                $root.find('.product').each(function() {
                    var tags = $(this).data('tags');
                    if (tags && tags.indexOf(tag) != -1) {
                        $(this).show();
                    }
                });
                // check if no products in group - hide group
                $root.find('.products').each(function() {
                    if ($(this).find('.product:visible').length < 1) $(this).hide();
                })
            }

        }

        function buildTagsFilters() {
            var $products = $root.find('.products .product'),
                $tags_filter = $root.find('.filters select[name="tags"]'),
                all_tags = [];

            // prepare tags
            $products.each(function() {
                var tags = $(this).data('tags');
                // console.log(tags);
                if (tags && tags.indexOf(', ')!=-1) {
                    all_tags = _.union(all_tags, tags.split(', '));
                }
                if (tags && tags.indexOf(', ')==-1) {
                    all_tags.push(tags);
                }
            });
            all_tags.sort();
            all_tags = _.uniq(all_tags);

            // render tags options
            _.each(all_tags,function(tag) {
                // console.log(tag);
                var $option = $('<option></option>');
                $option.text(tag);
                $option.attr('value',tag);
                $tags_filter.append($option);
            });

        }

        function explodeKeyvisualH2Letters() {
            var words = $('.UICollection .keyvisual .filters h2').text().split('');
            $('.UICollection .keyvisual .filters h2').empty();
            $.each(words, function(i, v) {
                if (v===' ') {
                    $('.UICollection .keyvisual .filters h2').append('<span>&nbsp;</span>');
                }
                else {
                    $('.UICollection .keyvisual .filters h2').append($('<span>').text(v));
                }
            });
        }

        function formatMoney() {
            var $prices = $('.UICollection .product h6 b'),
                currencyCode = $('.UIHeader .currency').data('currency');

            $prices.each(function() {
                var $price = $(this),
                    priceInCents = $price.data('price'),
                    priceFormattedAndRounded = 0;

                if (priceInCents) {
                    priceFormattedAndRounded = Math.round(priceInCents / 100);
                    // console.log(priceInCents,priceFormattedAndRounded);
                    $price.html(priceFormattedAndRounded +' <sup>'+ currencyCode+'</sup>');
                }

            });

        }

        function hideEmptyCategories() {

            $('.UICollection.all .products').each(function() {
                if ($(this).find('.product').length==0) {
                    $(this).hide();
                }
            });

            $('.UICollection .products').each(function() {
                if ($(this).find('.product').length==0) {
                    $(this).find('.empty').show();
                    $(this).find('.head').hide();
                }
            });

        }

    }

    function contactController() {

        (function() {
            events();
        }())

        function events() {

            // disable dev links
            $root.find('.info a[href="/"]').off('click.wbshck').on('click.wbshck',function(e) {
                e && e.preventDefault();
            });

        }

    }

    function cartController() {

        (function() {
            events();
        }());

        function events() {

            $('.UICart .qty .icon').off('click.wbshck').on('click.wbshck',function(e) {
                e && e.preventDefault();
                increaseCartItemQuantity($(this));
            });

            // $('.UICart .back').off('click').on('click',function(e) {
            //     e && e.preventDefault();
            //     window.history.back();
            // });

        }

        function increaseCartItemQuantity($btn) {

            var $qty = $btn.closest('.qty').find('input.quantity'),
                qty = ($qty.val()) ? parseInt($qty.val(),10) : 0,
                min = 1;


            if ($btn.hasClass('up')) {
                qty++;
                $qty.val(qty);
                // console.log('up',qty);
            }
            else {
                qty--;
                if (qty < min) qty=min;
                $qty.val(qty);
                // console.log('down',qty);
            }

            // update form
            $('.UICart .cart button[name="update"]').trigger('click');

        }


    }


    // helpers
    function getYoutubeIdFromUrl(url) {
        var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
        var match = url.match(regExp);

        return (match && match[2].length === 11) ? match[2] : null;
    }

    function isTouchDevice() {
        var touch = false;
        try {
            // is touch device
            document.createEvent('TouchEvent');
            $('html, body').removeClass('no-touch');
            touch = true;
        }
        catch (e) {
            // is not touch  device
            $('html, body').addClass('no-touch');
            touch = false;
        }
        return touch;
    }

    function scrollToAnchor(aid) {
        var aTag = $('a[name="'+ aid.replace('#','') +'"]');
        // console.log(aTag.offset().top);
        $('html, body').animate({scrollTop: aTag.offset().top},500);
    }

    function getQueryParams(qs) {
        qs = qs.split('+').join(' ');

        var params = {},
            tokens,
            re = /[?&]?([^=]+)=([^&]*)/g;

        while (tokens = re.exec(qs)) {
            params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
        }

        return params;
    }

    function loadDelayedGraphics($items) {
        if ($items) {
            $items.each(function() {
                if ($(this).attr('delay-src')) {
                    if ($(this).prop('tagName') == 'IMG') {
                        // console.log($(this).prop('tagName'),$(this).attr('delay-src'));
                        (new Image()).src = $(this).attr('delay-src');
                    }
                    $(this).attr('src',$(this).attr('delay-src'));
                    $(this).removeAttr('delay-src');
                }
            });
        }
    }

    function roundMoney(money) {
        var out = money;
        out = out.toFixed(2);
        out = out.replace('.00','');
        return out;
    }

    function setCookie(key, value, expiry) {  //(key,value,expiry in days)
        var expires = new Date();
        expires.setTime(expires.getTime() + (expiry * 24 * 60 * 60 * 1000));
        document.cookie = key + '=' + value + ';expires=' + expires.toUTCString();
    }

    function getCookie(key) {
        var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
        return keyValue ? keyValue[2] : null;
    }

    function eraseCookie(key) {
        var keyValue = getCookie(key);
        setCookie(key, keyValue, '-1');
    }

    function marvelModal() {
      var params = getQueryParams(window.location.search);
      var marvelParam = params.marvel_modal
      if($('.custom-image-popup').length > 0) {
        setTimeout(function(){
          if(!getCookie('custom-image-popup')) {
            $('.custom-image-popup').fadeIn();
          }
        }, 3000);
        $('.custom-image-popup .close').on('click', function(e) {
          e.preventDefault();
          $('.custom-image-popup').fadeOut();
          setCookie('custom-image-popup', 1, 7)
        })
      }
    }
    marvelModal();

    function localizationSelector() {
      var params = getQueryParams(window.location.search);

      //if(params.localization == 'true') {
        $('.currency.noselect').hide();
        $('.localization.currency.noselect').show();

        $('.UIHeader .currency.localization .selector a:not(.up,.down)').off('click.wbshck.notif').on('click.wbshck.notif',function(e) {
          e.preventDefault();
          var form = $(this).closest('.selector').find('form');
          var language_code = form.find('.language_code');
          var lc_value = $(this).attr('href');

          if(language_code) {
            language_code.val(lc_value);
          }

          $('.UIHeader .currency .selected').removeClass('active');
          $('.UIHeader .currency .selector').removeClass('active');

          if (form) form.submit();
        });

        $('.localization .select-slide').each(function() {
          $(this).slick({
            infinite: false,
            vertical: true,
            slidesToShow: 10,
            slidesToScroll: 10,
            dots: false,
            prevArrow: $(this).parent().find('a.up'),
            nextArrow: $(this).parent().find('a.down'),
            responsive: [{
              breakpoint: 992,
              settings: {
                slidesToShow: 5,
                slidesToScroll: 1
              }
            }]
          });
        });
      //} // end
    }

    localizationSelector()

    function quickNav() {
        var params = getQueryParams(window.location.search);
        
        // if(params.new_nav) {
            // $('nav.new,.icon.user,.localization').hide();
            // $('.quick-nav .localization').show();
            // $('nav.new.latest').show();

            $('.quick-nav-toggle-btn').on('click', function() {
                if($(this).hasClass('active')) {
                    $('.quick-nav').hide();
                } else {
                    $('.quick-nav').show();
                }
                $(this).toggleClass('active')
            })
        // }
    }

    quickNav();
});

// run on document ready
$(document).ready(function() {
  WbshckWeb($,_,TweenMax);
});
